const pt = {
  papelFabrica: { dono: 'TI', administrador: 'Administrador', gestor: 'Gestor', operador: 'Operador', leitura: 'Leitura' },
  nome: 'Painel admin',
  abas: { painel: 'Painel', modulos: 'Módulos', tenants: 'Tenants e workspaces', usuarios: 'Usuários e acessos', auditoria: 'Auditoria', saude: 'Saúde', 'historico-telas': 'Histórico telas', erros: 'Logs de erros', 'tela-entrada': 'Tela de entrada', 'uso-ia': 'Uso de IA' },
  estadoJob: { pendente: 'pendente', rodando: 'rodando', concluido: 'concluído', erro: 'erro', enviado: 'enviado' },
  painel: {
    titulo: 'Saúde do sistema',
    postgres: 'PostgreSQL',
    redis: 'Redis',
    worker: 'Worker',
    versao: 'Versão no ar',
    online: 'Online',
    fora: 'Fora do ar',
    ativo: 'Ativo',
    parado: 'Parado',
    ultimoSinal: 'Último sinal {{quando}}',
    semSinal: 'Sem sinal do worker',
    jobs24h: 'Jobs nas últimas 24 horas',
    jobsEstado: { pendente: 'Pendentes', rodando: 'Rodando', concluido: 'Concluídos', erro: 'Com erro' },
    semJobs: 'Nenhum job nas últimas 24 horas.',
    fila: 'Fila de envio (outbox) nas últimas 24 horas',
    erros: 'Erros recentes',
    errosJobs: 'Jobs com erro',
    errosWebhooks: 'Webhooks que falharam',
    semErros: 'Nenhum erro recente. Tudo certo por aqui.',
    tentativas_one: '{{count}} tentativa', tentativas_other: '{{count}} tentativas',
    atualizar: 'Atualizar',
  },
  modulos: {
    instalado: 'Instalado',
    naoInstalado: 'Não instalado',
    fixo: 'Fixo',
    versao: 'Versão {{v}}',
    dependeDe: 'Depende de',
    dependentes: 'Dependentes',
    usaSeInstalado: 'Usa, se instalado',
    nenhum: 'Nenhum',
    instalar: 'Instalar',
    desinstalar: 'Desinstalar',
    instaladoEm: 'Instalado em {{data}}',
    confirmarInstalar: 'Instalar {{nome}}?',
    instalarTambem: 'Também serão instalados: {{lista}}.',
    instalarSem: 'Nenhuma dependência extra para instalar.',
    confirmarDesinstalar: 'Desinstalar {{nome}}?',
    desinstalarTexto: 'Menus e rotas somem para todo o tenant, mas os dados ficam preservados. Dá para instalar de novo quando quiser.',
    bloqueado: 'Desinstale antes: {{lista}}.',
    fixoAviso: 'Módulo fixo, não pode ser desinstalado.',
    okInstalado: 'Instalado: {{lista}}',
    okJaInstalado: 'O módulo já estava instalado',
    okDesinstalado: '{{nome}} desinstalado',
    ligadoNoWorkspace: 'Ligado neste workspace',
    desligadoNoWorkspace: 'Desligado neste workspace',
    porWorkspace: 'Por workspace',
    porWorkspaceAjuda: 'Módulo opcional: nasce desligado e só aparece no workspace que o ligar (os dados ficam guardados).',
    ligarNoWorkspace: 'Ligar neste workspace',
    desligarNoWorkspace: 'Desligar neste workspace',
    confirmarLigar: 'Ligar {{nome}} neste workspace?',
    ligarTexto: 'Menus, rotas, tools do MCP e indicadores do módulo passam a aparecer em {{workspace}}, para todas as empresas.',
    confirmarDesligar: 'Desligar {{nome}} neste workspace?',
    desligarTexto: 'Menus, rotas, tools do MCP e indicadores do módulo somem de {{workspace}}. Os dados ficam guardados e voltam ao ligar de novo.',
    okLigado: '{{nome}} ligado neste workspace',
    okDesligado: '{{nome}} desligado neste workspace',
    menu: 'Menu',
    abas: 'Abas',
    permissoes_one: '{{count}} permissão', permissoes_other: '{{count}} permissões',
    vazio: 'O catálogo de módulos está vazio.',
  },
  tenants: {
    workspaces: 'Workspaces do tenant',
    novoWorkspace: 'Novo workspace',
    nome: 'Nome',
    slug: 'Identificador',
    slugAjuda: 'Letras minúsculas, números e hífen. Em branco, é gerado a partir do nome.',
    sandbox: 'Sandbox',
    sandboxAjuda: 'Ambiente de teste, separado dos dados reais.',
    atual: 'Atual',
    membros_one: '{{count}} membro', membros_other: '{{count}} membros',
    renomear: 'Renomear',
    marcarSandbox: 'Marcar como sandbox',
    desmarcarSandbox: 'Tirar de sandbox',
    editarWorkspace: 'Editar workspace',
    excluirWorkspace: 'Excluir o workspace {{nome}}?',
    excluirWorkspaceTexto: 'Nada é apagado: o workspace é arquivado com tudo o que tem dentro e ninguém entra mais nele (as sessões e chaves de API dele param na hora). Só quem é TI num workspace de produção exclui, e nunca o workspace em uso.',
    excluirTenant: 'Excluir o tenant {{nome}}?',
    excluirTenantTexto: 'Nada é apagado: o tenant é cancelado e arquivado com todos os workspaces e dados, e ninguém dele entra mais. Some desta lista. O próprio tenant não pode ser excluído.',
    workspaceCriado: 'Workspace criado',
    vazioWorkspaces: 'Nenhum workspace encontrado.',
    plataforma: 'Plataforma',
    plataformaTexto: 'Todos os tenants da plataforma. Esta seção aparece só para administradores da plataforma.',
    novoTenant: 'Novo tenant',
    tenant: 'Tenant',
    plano: 'Plano',
    creditosQtd_one: '{{valor}} crédito', creditosQtd_other: '{{valor}} créditos',
    creditos: 'Créditos',
    estado: 'Estado',
    estados: { ativo: 'Ativo', suspenso: 'Suspenso', cancelado: 'Cancelado' },
    qtdWorkspaces: 'Workspaces',
    qtdUsuarios: 'Usuários',
    criadoEm: 'Criado em',
    donoNome: 'Nome de quem será TI',
    donoEmail: 'E-mail de quem será TI',
    workspaceInicial: 'Nome do primeiro workspace',
    conviteAviso: 'O dono recebe um e-mail com o link para definir a senha e entrar. O link vale por 72 horas.',
    tenantCriado: 'Tenant criado e convite enviado',
    editarTenant: 'Editar {{nome}}',
    vazioTenants: 'Nenhum tenant cadastrado.',
    semAcesso: 'Só administradores da plataforma veem os tenants.',
  },
  usuarios: {
    subabas: { membros: 'Membros', convites: 'Convites', papeis: 'Papéis', pedidos: 'Pedidos' },
    pedidos: {
      texto: 'Pedidos de troca de e-mail ou de nome de usuário feitos pelas pessoas em Minha conta. Aprovar o nome de usuário muda na hora; aprovar o e-mail envia o link de confirmação ao endereço novo.',
      pendentes: 'Pedidos pendentes',
      nenhumPendente: 'Nenhum pedido pendente.',
      recentes: 'Decididos nos últimos 30 dias',
      vazioTitulo: 'Nenhum pedido',
      vazioTexto: 'Quando alguém pedir a troca do e-mail ou do nome de usuário em Minha conta, o pedido aparece aqui e você recebe um aviso.',
      atual: { email: 'E-mail de hoje', usuario: 'Nome de usuário de hoje' },
      novo: { email: 'E-mail pedido', usuario: 'Nome de usuário pedido' },
      semEmail: 'Sem e-mail',
      aprovar: 'Aprovar',
      recusar: 'Recusar',
      cancelar: 'Cancelar',
      status: { aprovado: 'Aprovado', recusado: 'Recusado' },
      decidido: 'Decidido por {{quem}} em {{quando}}.',
      motivo: 'Motivo: {{motivo}}',
      aprovadoEmail: 'Pedido aprovado: enviamos o link de confirmação ao e-mail novo',
      aprovadoUsuario: 'Pedido aprovado: o nome de usuário já mudou',
      recusado: 'Pedido recusado',
      recusarTitulo: 'Recusar o pedido',
      motivoCampo: 'Motivo (opcional)',
      motivoAjuda: 'A pessoa lê o motivo em Minha conta.',
    },
    // Val1 (papel por sub-sistema, 28/10): a árvore sub-sistema > página > ação e a exceção por pessoa.
    arvore: {
      titulo: 'Acesso por sub-sistema, página e ação',
      ajudaSemSubsistemas: 'Os sub-sistemas estão desligados neste workspace: a divisão padrão serve de guia. Marque o grupo para dar todas as páginas e ações dele; abra-o para desmarcar páginas e ações (as ações são do módulo e valem para todas as páginas dele).',
      comuns: 'Comuns a todos',
      outras: 'Outras permissões',
      contagem: '{{marcadas}} de {{total}} páginas',
      acoesDoModulo: 'Ações do módulo {{modulo}} (valem para todas as páginas dele)',
      excecao: 'exceção',
      semConceder: 'Você não tem esta ação para conceder',
      ajuda: 'Marque o sub-sistema em que o papel trabalha: ele mostra só as páginas desse sub-sistema, e só ele fica aberto e marcado. Abra-o para desmarcar páginas e, em cada página, as ações. As ações são do módulo e valem para todas as páginas dele; a página que está em mais de um sub-sistema é uma só (marcar aqui a abre onde quer que apareça).',
      tambemEm: 'também em: {{lista}}',
      resumo: {
        papel: 'Este papel abre',
        pessoa: 'Esta pessoa abre',
        voce: 'Você abre',
        paginas_one: '{{count}} página',
        paginas_other: '{{count}} páginas',
        comSubsistemas: '{{sujeito}}: {{paginas}} em {{lista}}',
        semSubsistemas: '{{sujeito}}: {{paginas}}',
        papelNenhuma: 'Este papel ainda não abre nenhuma página.',
        pessoaNenhuma: 'Esta pessoa ainda não abre nenhuma página.',
        voceNenhuma: 'Você ainda não abre nenhuma página.',
      },
    },
    acessoPersonalizado: 'Acesso personalizado',
    filtroAcesso: 'Filtrar por acesso',
    acessoTodos: 'Todo acesso',
    acessoPessoa: {
      titulo: 'Acesso desta pessoa',
      ajuda: 'Parte da soma dos papéis. Marque ou desmarque para conceder ou retirar só para esta pessoa (exceção, registrada na auditoria). Prefira resolver por papéis.',
      desativado: 'Membro desativado: o acesso fica só para leitura; reative para editar',
      salvar: 'Salvar acesso',
      voltar: 'Voltar só aos papéis',
      salvo: 'Acesso da pessoa salvo',
      retiradasJunto: 'Retiradas junto com a ação concedida (você não abre estas páginas): {{paginas}}.',
    },
    convidar: 'Convidar',
    novoPapel: 'Novo papel',
    nome: 'Nome',
    email: 'E-mail',
    papelUnico: 'Papel',
    papeis: 'Papéis',
    estado: 'Estado',
    ativo: 'Ativo',
    inativo: 'Desativado',
    ultimoAcesso: 'Último acesso',
    formasAcesso: 'Acesso',
    nunca: 'Nunca entrou',
    desde: 'Membro desde',
    empresas: 'Empresas permitidas',
    empresasPelaFicha: 'As empresas desta pessoa seguem as verticais da ficha de funcionário dela (Pessoas): mudando as verticais lá, esta lista acompanha.', 
    empresasAjuda: 'Sem nenhuma marcada, o usuário acessa todas as empresas do workspace. Com empresas marcadas, ele só vê os dados delas (financeiro, contas, compras e folha) e só escolhe entre elas no filtro de empresa do topo. Quem é TI vê sempre todas. Os relatórios consolidados e o Painel do grupo dependem da permissão de consolidado do papel ou da exceção abaixo.',
    empresasVeTodasRestrito: 'Este usuário não tem lista de empresas: ele vê todas as empresas do workspace. Só quem vê todas as empresas muda a lista dele.',
    empresasOutras: 'Ele também tem empresas que você não vê; elas continuam como estão.',
    empresasAjudaRestrito: 'Com empresas marcadas, o usuário só vê os dados delas (financeiro, contas, compras e folha) e só escolhe entre elas no filtro de empresa do topo. Como você não vê todas as empresas, a lista precisa manter ao menos uma marcada, e as empresas que você não vê continuam como estão. Os relatórios consolidados e o Painel do grupo dependem da permissão de consolidado do papel ou da exceção abaixo.',
    semEmpresas: 'Nenhuma empresa cadastrada neste workspace.',
    salvarPapeis: 'Salvar papéis',
    salvarEmpresas: 'Salvar empresas',
    consolidado: 'Ver o consolidado das empresas (relatórios e Painel do grupo), como exceção',
    modoSimples: 'Modo simples',
    modoSimplesLigar: 'Ligar o modo simples para esta pessoa',
    modoSimplesAjuda: 'Esconde as abas e os campos avançados. A pessoa também pode ligar ou desligar em Minha conta; nenhuma permissão muda.',
    modoSimplesSalvar: 'Salvar modo simples',
    estilo: 'Estilo de interface',
    estiloAjuda: 'Fixa o estilo desta pessoa neste workspace: ela não consegue trocar. Sem fixar, vale a escolha dela ou o padrão do workspace.',
    estiloSeguir: 'Não fixar (seguir a escolha da pessoa ou o padrão do workspace)',
    estiloSalvar: 'Salvar estilo',
    estiloFixado: 'Estilo fixado: {{nome}}',
    definirEstilo: 'Definir estilo',
    estiloLoteTitulo: 'Definir estilo de {{count}} pessoa(s)',
    estiloLoteSeguir: 'Não fixar (seguir a escolha da pessoa ou o padrão do workspace)',
    estiloLoteAplicar: 'Aplicar',
    selecionados_one: '{{count}} selecionado',
    selecionados_other: '{{count}} selecionados',
    limparSelecao: 'Limpar seleção',
    selecionar: 'Selecionar {{nome}}',
    estiloAplicado: 'Estilo definido para {{count}} pessoa(s)',
    estiloParcial: 'Estilo definido para {{feitos}} de {{total}} pessoas; as demais continuam marcadas. {{erro}}',
    consolidadoAjuda: 'Libera só para esta pessoa a visão somada das empresas permitidas, sem mudar o papel.',
    promoverDono: 'Promover a TI',
    promoverTitulo: 'Promover {{nome}} a TI?',
    promoverTexto: 'O papel TI tem acesso total ao workspace e pode promover outros. Só quem é TI faz esta promoção.',
    desativar: 'Desativar',
    reativar: 'Reativar',
    desativarTitulo: 'Desativar {{nome}}?',
    remover: 'Remover do workspace',
    removido: 'Membro removido do workspace',
    removerTitulo: 'Remover {{nome}} do workspace?',
    removerTexto: 'A pessoa sai da lista de membros e pode ser convidada de novo. Nada é apagado: a auditoria e o histórico do que ela fez continuam.',
    desativarTexto: 'A pessoa perde o acesso a este workspace na hora. O histórico dela fica preservado e dá para reativar depois.',
    autoDesativacao: 'Você não pode desativar a si mesmo.',
    voce: 'você',
    papelDonoAviso: 'Para dar a alguém o papel TI use o botão Promover a TI.',
    vazioMembros: 'Nenhum membro encontrado.',
    filtroSituacao: 'Situação',
    todos: 'Todos',
    soAtivos: 'Ativos',
    soInativos: 'Desativados',
    convite: {
      titulo: 'Convidar para o workspace',
      tipo: 'Tipo',
      tipos: { funcionario: 'Funcionário', parceiro: 'Cliente ou parceiro', convidado: 'Convidado' },
      tipoAjuda: {
        funcionario: 'Acesso ao sistema ligado à ficha em Pessoas; o papel vem da função.',
        parceiro: 'Acesso ao Portal do cliente, sem papel do sistema.',
        convidado: 'Quem não é funcionário (contador externo, consultor): só o papel.',
      },
      origem: 'Funcionário',
      origens: { existente: 'Já cadastrado em Pessoas, sem acesso', novo: 'Cadastrar agora (só nome, e-mail, departamento, função e empresa)' },
      funcionario: 'Funcionário sem acesso',
      funcionarioAjuda: 'Só aparecem os que ainda não têm usuário nem convite.',
      acesso: 'Como a pessoa vai entrar',
      acessos: { email: 'Convite por e-mail', usuario: 'Nome de usuário e senha provisória (sem e-mail)' },
      acessoAjuda: {
        email: 'O link do convite vai por e-mail e a pessoa define a senha. Pode ser o e-mail pessoal: ela troca pelo institucional depois, em Minha conta, sem perder nada.',
        usuario: 'Para quem ainda não tem e-mail: você entrega o nome de usuário e a senha provisória, que vale 72 horas e é trocada no primeiro acesso. A recuperação da senha fica com o administrador.',
      },
      emailAcesso: 'E-mail de acesso (se não for o da ficha)',
      emailAcessoAjuda: 'Ex.: o e-mail pessoal, antes do institucional. O e-mail de contato da ficha continua o mesmo.',
      emailContato: 'E-mail de contato (opcional)',
      usuario: 'Nome de usuário',
      usuarioAjuda: 'Em branco: {{exemplo}} (gerado pelo nome; se já existir, ganha um número). Sem "@" e sem acento.',
      criarAcesso: 'Criar acesso',
      entrarEmail: 'Entrar com e-mail',
      entrarUsuario: 'Entrar com nome de usuário',
      formasAjuda: 'Marque uma ou as duas. Com e-mail, o convite leva o link para a pessoa criar a própria senha (e o nome de usuário, se marcado). Só nome de usuário e sem e-mail: a senha provisória aparece uma vez para você entregar.',
      formaObrigatoria: 'Escolha ao menos uma forma de acesso',
      emailFichaAjuda: 'Vazio: o e-mail da ficha. Pode ser outro (o pessoal, por exemplo).',
      emailOpcionalAjuda: 'Opcional quando só o nome de usuário está marcado: havendo e-mail, a pessoa recebe o nome de usuário e o link para criar a senha.',
      empresa: 'Empresa',
      empresaAtual: 'A empresa atual',
      papelFuncao: 'Papel de acesso',
      papelFuncaoAjuda: 'O acesso vem do papel. A função sugere um papel (já vem preenchido); troque se precisar. Mudar a função depois não muda o acesso.',
      novoAjuda: 'CPF e admissão ficam para completar na ficha (selo "Dados a completar").',
      parceiro: 'Cliente ou parceiro',
      papelPortal: 'Papel no Portal',
      semPortal: 'O Portal do cliente não está instalado neste workspace.',
      semPermissaoPortal: 'Você não tem a permissão de acessos do Portal.',
      semPessoas: 'O módulo Pessoas não está instalado neste workspace.',
      semPermissaoPessoas: 'Você não tem a permissão de editar em Pessoas.',
      enviadoPortal: 'Convite do Portal enviado',
      enviar: 'Enviar convite',
      enviado: 'Convite enviado',
      expiraEm: 'Expira {{quando}}',
      expirado: 'Expirado',
      reenviar: 'Reenviar',
      cancelar: 'Cancelar convite',
      cancelarTitulo: 'Cancelar o convite de {{email}}?',
      cancelarTexto: 'O link já enviado deixa de funcionar.',
      reenviado: 'Convite reenviado com novo link',
      cancelado: 'Convite cancelado',
      convidadoPor: 'Convidado por {{nome}}',
      vazio: 'Nenhum convite pendente.',
      nomeAjuda: 'Opcional. A pessoa pode ajustar ao aceitar.',
      editar: 'Editar',
      editarTitulo: 'Editar convite',
      editado: 'Convite atualizado. O link enviado continua valendo.',
      editadoNovoLink: 'Convite enviado ao novo e-mail. O link anterior deixou de abrir.',
      emailTrocaAviso: 'Trocar o e-mail cancela este convite e envia um novo link ao endereço novo; o link atual deixa de abrir. Mudar o resto mantém o link e o prazo.',
      empresasConvite: 'Empresas',
      empresasConviteAjuda: 'Nenhuma marcada: todas as empresas que você vê.',
      salvar: 'Salvar convite',
      detalheTitulo: 'Convite de {{nome}}',
      detalheSemFicha: 'Esta pessoa não tem ficha no sistema.',
      criarFicha: 'Criar ficha',
      criarFichaAjuda: 'Cria a pessoa em Cadastros > Pessoas e empresas com o nome e o e-mail do convite.',
      fichaCriada: 'Ficha criada',
      abrirFicha: 'Abrir a ficha de {{nome}}',
      verConvite: 'Ver o convite de {{nome}}',
    },
    papel: {
      deFabrica: 'De fábrica',
      personalizado: 'Personalizado',
      membros_one: '{{count}} membro', membros_other: '{{count}} membros',
      permissoes_one: '{{count}} permissão', permissoes_other: '{{count}} permissões',
      imutavel: 'Papéis de fábrica não podem ser editados. Crie um papel personalizado para ajustar permissões.',
      matriz: 'Permissões por módulo',
      marcarTodas: 'Marcar todas',
      nucleo: 'Núcleo',
      nomeLabel: 'Nome do papel',
      criarTitulo: 'Novo papel personalizado',
      duplicar: 'Duplicar',
      duplicarTitulo: 'Duplicar o papel {{nome}}',
      duplicarTexto: 'O papel novo começa com as permissões, os níveis dos assistentes e as notificações padrão de {{nome}}. Ajuste o que quiser antes de criar.',
      nomeCopia: '{{nome}} (cópia)',
      copiaParcial: 'Papel criado, mas os níveis dos assistentes ou as notificações padrão não foram copiados: {{erro}}',
      criado: 'Papel criado',
      excluir: 'Excluir papel',
      excluirTitulo: 'Excluir o papel {{nome}}?',
      excluirTexto: 'Só é possível excluir papéis sem membros nem convites pendentes.',
      excluido: 'Papel excluído',
      vazio: 'Nenhum papel encontrado.',
      semModulos: 'Nenhum módulo com permissões instalado.',
    },
    conta: {
      titulo: 'Acesso à conta',
      semEmail: 'Sem e-mail (entra pelo nome de usuário)',
      usuarioRotulo: 'Usuário: {{usuario}}',
      emailTexto: 'O link de confirmação vai ao e-mail novo; a troca só vale depois dela e o e-mail de hoje recebe um aviso. Histórico, papéis e verificação em duas etapas ficam. Não vale para quem também é membro de outro workspace onde você não é TI.',
      emailNovo: 'E-mail novo',
      trocarEmail: 'Trocar e-mail',
      adicionarEmail: 'Adicionar e-mail',
      emailEnviado: 'Se o endereço puder ser usado, o link de confirmação foi enviado para ele.',
      novaSenha: 'Nova senha provisória',
      novaSenhaTexto: 'Para a conta sem e-mail que perdeu a senha: a recuperação é com o administrador.',
      novaSenhaConfirmar: 'A senha atual e as sessões abertas da pessoa deixam de valer. A nova senha aparece uma vez para você entregar; vale 72 horas e é trocada no primeiro acesso.',
    },
    acessoCriado: {
      titulo: 'Acesso criado',
      texto: 'Entregue estes dados à pessoa. A senha provisória aparece só agora, vale até {{quando}} e será trocada no primeiro acesso.',
      usuario: 'Nome de usuário',
      senha: 'Senha provisória',
      copiar: 'Copiar os dados',
      copiado: 'Copiado',
      fechar: 'Já entreguei',
    },
    mfaTitulo: 'Verificação em duas etapas', mfaResetar: 'Redefinir verificação em duas etapas', mfaResetarTexto: 'Use quando a pessoa perdeu o celular e os códigos de backup. O aplicativo atual deixa de valer e, se o papel exigir, ela configura de novo no próximo login.', mfaResetado: 'Verificação em duas etapas redefinida',
    teste: { titulo: 'Usuário de teste', selo: 'Teste', texto: 'Conta de demonstração sem login próprio: quem tem "Simular usuário de teste" entra nela pelo menu do perfil. Só a conta que nunca entrou vira teste. Marcar tira a senha, encerra as sessões e revoga chaves de API, assistentes e conexões da conta.', seloSimulacao: 'Simulação', textoSimulacao: 'Usuário de simulação deste papel: nasce com o papel e sai com ele, não tem login próprio e só o administrador da plataforma o vê e o simula. O acesso dele muda aqui como o de qualquer pessoa (papel, empresas e exceções), menos TI.', marcar: 'Marcar como usuário de teste', desmarcar: 'Deixar de ser usuário de teste', marcado: 'Marcado como usuário de teste', desmarcado: 'Deixou de ser usuário de teste', soSemEmail: 'Só a conta sem e-mail (acesso pelo nome de usuário) vira usuário de teste.' },
    acaoPermissao: {
      consolidado: 'Consolidado das empresas (relatórios e Painel do grupo)',
      erros: { ver: 'Ver o log de erros' },
      adm: { usar: 'Usar o ADM' },
      // D1: permissões dos sub-sistemas (o código é `subsistema.<x>.usar` e `nucleo.subsistemas.configurar`).
      subsistemas: { configurar: 'Configurar sub-sistemas' },
      erp: { usar: 'Usar o ERP' },
      crm: { usar: 'Usar o CRM' },
      suporte: { usar: 'Usar o Suporte' },
      automacoes: { usar: 'Usar as Automações' },
      rh: { usar: 'Usar o RH' },
      ver: 'Ver',
      criar: 'Criar',
      editar: 'Editar',
      excluir: 'Excluir',
      importar: 'Importar',
      mesclar: 'Mesclar',
      modulos: 'Módulos',
      usuarios: 'Usuários',
      papeis: 'Papéis',
      auditoria: 'Auditoria',
      tenants: 'Tenants',
      fechar: 'Fechar',
      confidencial: 'Salário, documentos e dados pessoais',
      campos_telas: 'Configurar os campos das telas',
      aprovar: 'Aprovar',
      salvar: 'Salvar',
      compartilhar: 'Compartilhar',
      agendar: 'Agendar envio',
      arquivos: 'Gerir a Central de Arquivos',
      // FUN 2026-10-15 (U7): permissões do módulo Automações por área.
      ver_todas: 'Ver todas as áreas',
      area_fiscal: 'Área Fiscal',
      area_dp: 'Área DP',
      area_bpo: 'Área BPO',
      area_legalizacao: 'Área Legalização',
      area_ti: 'Área TI',
      simular_usuario: 'Simular usuário de teste',
    },
    // Val5 (29/10): rótulo próprio da ação de um módulo (`<modulo>.<acao>`), quando o genérico por ação não diz o que ela faz.
    acaoModulo: {
      agenda: { cancelar: 'Cancelar e remarcar agendamentos', bloquear: 'Bloquear horários' },
      assinaturas: { faturar: 'Faturar contrato', pausar: 'Pausar e reativar contrato', configurar: 'Configurar assinaturas' },
      ausencias: { exportar: 'Exportar ausências' },
      automacoes: { publicar: 'Publicar fluxo', disparar: 'Disparar envio em massa', configurar: 'Configurar automações' },
      cadastros: { exportar: 'Exportar contatos e empresas', arquivar: 'Arquivar e desarquivar' },
      compras: { enviar: 'Enviar pedido ao fornecedor' },
      configuracoes: { empresas: 'Gerenciar empresas do grupo', campos: 'Gerenciar campos personalizados' },
      conversas: { configurar: 'Configurar canais e atendimento', templates: 'Gerenciar templates do WhatsApp' },
      documentos: { enviar: 'Enviar para assinatura', cancelar: 'Cancelar assinatura' },
      estoque: { importar: 'Importar produtos' },
      folha: { configurar: 'Configurar a folha' },
      pessoas: { importar: 'Importar funcionários', desligar: 'Desligar funcionário', convidar: 'Convidar para o sistema', configurar: 'Configurar estrutura de pessoas' },
      pipeline: { exportar: 'Exportar negociações e tarefas', ganhar_perder: 'Marcar venda ou perda (e reabrir)', configurar: 'Configurar o CRM', metas: 'Definir metas e equipes', enviar: 'Enviar e-mail e proposta', em_massa: 'Ações em massa' },
      relatorios: { publicar_portal: 'Publicar relatório no Portal' },
      tarefas: { configurar: 'Configurar quadros e projetos' },
      treinamento: { atribuir: 'Atribuir treinamentos', acompanhar: 'Acompanhar o progresso da equipe' },
    },
  },
  erros: {
    intro: 'Quando uma ação dá erro, o sistema registra o que a pessoa tentava fazer, o erro e o que estava preenchido (sem senha nem documento). Assim a equipe, ou uma IA de apoio, encontra, corrige e refaz a ação antes de a pessoa precisar avisar. Cada erro novo também chega nas Notificações.',
    quando: 'Quando',
    pessoa: 'Pessoa',
    acao: 'Ação que tentava',
    tela: 'Tela',
    erro: 'Erro',
    situacao: 'Situação',
    status: { novo: 'Novo', analise: 'Em análise', corrigido: 'Corrigido' },
    filtros: { abertos: 'Em aberto', novo: 'Novos', analise: 'Em análise', corrigido: 'Corrigidos', todos: 'Todos' },
    vazio: 'Nenhum erro registrado',
    vazioFiltro: 'Nenhum erro neste filtro',
    vazioTexto: 'Para ver como funciona, use "Simular erro".',
    simular: 'Simular erro',
    // Ajustes do CRM 27/10 (decisão 5): o "Dê seu feedback" das telas também entra no log.
    feedback: 'Feedback',
    acaoFeedback: 'Dê seu feedback',
    gravado: { botao: 'Botão', link: 'Link', opcao: 'Opção', secao: 'Seção', campo: 'Campo', carregarTela: 'Carregar a tela', foraDeClique: 'Fora de um clique', simularErro: 'Simular erro (teste)', abrirTela: 'Abrir a tela', janela: 'janela' },
    textoFeedback: 'O que a pessoa sugeriu',
    erroDeTeste: 'Erro de teste: o botão simulou uma falha ao salvar',
    detalhe: 'Erro registrado',
    acaoTentava: 'Ação que a pessoa tentava',
    preenchido: 'O que estava preenchido',
    nadaPreenchido: 'Nenhum campo aberto.',
    navegador: 'Navegador',
    notas: 'Notas da equipe',
    notaPlaceholder: 'Causa, correção feita, versão...',
    notaSalva: 'Nota salva',
    copiarRelato: 'Copiar relato para a IA',
    copiado: 'Relato copiado',
    naoCopiou: 'Não deu para copiar. Selecione o texto e copie.',
    executarDeNovo: 'Executar a ação de novo',
    executou: 'Ação executada de novo',
    abrirTela: 'Abrir a tela',
    soNaMesmaAba: 'Executar de novo só funciona na mesma aba do navegador em que o erro aconteceu. Fora dela, "Abrir a tela" leva ao mesmo lugar.',
    emAnalise: 'Em análise',
    marcarCorrigido: 'Marcar corrigido',
    reabrir: 'Reabrir',
    mudou: { novo: 'Erro reaberto', analise: 'Erro em análise', corrigido: 'Erro marcado como corrigido' },
    dadosOcultos: 'O que estava preenchido fica oculto: o erro é de uma empresa ou de um módulo que você não vê.',
    relato: {
      intro: 'Erro numa tela do MalgoOS. Analise a causa, proponha a correção no código e diga como refazer o que a pessoa tentava fazer.',
      quando: 'Quando',
      pessoa: 'Pessoa',
      acao: 'Ação que ela tentava',
      tela: 'Tela',
      origem: 'Origem',
      erro: 'Erro',
      requestId: 'request_id (log da API)',
      pilha: 'Pilha',
      semPilha: '(sem pilha)',
      dados: 'Dados preenchidos no momento',
      dadosOcultos: '(ocultos para quem copiou)',
      navegador: 'Navegador',
    },
  },
  auditoria: {
    data: 'Data',
    usuario: 'Usuário',
    acao: 'Ação',
    entidade: 'Entidade',
    registro: 'Registro',
    ip: 'IP',
    requisicao: 'Requisição',
    todosUsuarios: 'Todos os usuários',
    todasEntidades: 'Todas as entidades',
    todasAcoes: 'Todas as ações',
    de: 'De',
    ate: 'Até',
    detalhe: 'Detalhe do registro',
    mudancas: 'Mudanças',
    campo: 'Campo',
    antes: 'Antes',
    depois: 'Depois',
    adicionado: 'Adicionado',
    removido: 'Removido',
    alterado: 'Alterado',
    semMudancas: 'Nenhuma diferença registrada neste evento.',
    verJson: 'Ver dados completos',
    ocultadoConteudo: 'O conteúdo deste registro foi ocultado pela sua permissão: falta acesso ao módulo dono do dado.',
    ocultadoCampos: 'Parte do conteúdo foi ocultada pela sua permissão.',
    sistema: 'Sistema',
    chaveApi: 'Chave de API',
    simuladoPor: 'simulado por {{nome}}',
    vazio: 'Nenhum registro para os filtros escolhidos.',
    limpar: 'Limpar filtros',
  },
  saude: {
    versoes: 'Versões',
    aplicacao: 'Aplicação',
    node: 'Node.js',
    postgres: 'PostgreSQL',
    worker: 'Worker',
    sinal: 'Sinal do worker',
    modulos: 'Módulos do catálogo',
    fila: 'Fila de envio (outbox)',
    filaAgora: 'Pendências no banco todo',
    filaMaisAntigo: 'o mais antigo {{quando}}',
    filaVazia: 'Nada pendente. A fila está em dia.',
    fila24h: 'Últimas 24 horas',
    jobsPorTipo: 'Jobs por tipo nas últimas 24 horas',
    tipo: 'Tipo',
    estado: 'Estado',
    total: 'Total',
    erros: 'Jobs com erro',
    semErros: 'Nenhum erro registrado.',
    tentativas_one: '{{count}} tentativa', tentativas_other: '{{count}} tentativas',
    webhooks: 'Webhooks que falharam',
    eventosErro: 'Eventos recebidos com erro',
    conector: 'Conector',
    resposta: 'Resposta',
    atualizar: 'Atualizar',
    semSinal: 'Sem sinal',
  },  // Fase 2 (W37): Histórico telas (antes e depois). As legendas dos itens vêm do catálogo, em pt.
  historico: {
    intro_one: '{{count}} tela comparada, antes e depois. Clique numa imagem para ampliar.',
    intro_other: '{{count}} telas comparadas, antes e depois. Clique numa imagem para ampliar.',
    geradoEm: 'Catálogo de {{quando}}.',
    antes: 'Antes',
    depois: 'Depois',
    celularAntes: 'Celular · antes',
    celularDepois: 'Celular · depois',
    semAntes: 'Novo, sem antes',
    semCaptura: 'Sem captura',
    imagem: '{{titulo}}: {{rotulo}}',
    imagemN: '{{titulo}}: {{rotulo}} ({{n}} de {{total}})',
    ampliar: 'Ampliar {{nome}}',
    oculta: 'Imagem oculta no modo discreto',
    vazioTitulo: 'Histórico de telas ainda não publicado',
    vazioTexto: 'As imagens ficam no servidor, fora do sistema. Publique o catálogo pelo roteiro da operação para elas aparecerem aqui.',
    vazioSemItens: 'O catálogo publicado não tem nenhuma tela.',
  },
  telaEntrada: {
    intro: 'A logo e a imagem de fundo do login e da saída valem para todos os workspaces, porque a tela aparece antes do login. Só o administrador da plataforma muda.',
    textos: {
      cartao: 'Textos da tela',
      ajuda: 'A chamada, o título e o subtítulo que aparecem ao lado do formulário no computador. Deixe em branco para usar o texto padrão (o cinza dentro do campo), que muda com o idioma de quem abre; o texto que você escrever vale para todos os idiomas.',
      kicker: 'Chamada (acima do título)',
      titulo: 'Título',
      subtitulo: 'Subtítulo',
      limite: '{{usados}} de {{max}} caracteres',
      salvar: 'Salvar textos',
      voltarPadrao: 'Voltar aos textos padrão',
      salvos: 'Textos da tela de entrada salvos.',
      restaurados: 'Textos padrão de volta na tela de entrada.',
    },
    padrao: 'Padrão',
    personalizada: 'Personalizada',
    atualizadaEm: 'Trocada em {{quando}}',
    escolher: 'Escolher imagem',
    trocar: 'Trocar imagem',
    salvar: 'Salvar',
    descartar: 'Descartar',
    voltarPadrao: 'Voltar ao padrão',
    confirmarPadraoTitulo: 'Voltar ao padrão?',
    confirmarPadraoFundo: 'A tela de entrada volta a mostrar a foto do farol para todos.',
    confirmarPadraoLogo: 'A tela de entrada volta a mostrar a logo da Malgo para todos.',
    salva: 'Tela de entrada atualizada',
    processando: 'Enviando e processando a imagem no servidor; pode levar até um minuto.',
    restaurada: 'Padrão restaurado',
    tipoInvalido: 'Escolha uma imagem PNG, JPG ou WebP. SVG e outros formatos não são aceitos.',
    grandeDemais: 'Arquivo acima de 20 MB. Escolha uma imagem menor.',
    naoAbriu: 'Não foi possível abrir esta imagem. Escolha outro arquivo.',
    resultado: 'Resultado do ajuste: {{largura}} × {{altura}} px, {{tamanho}}. Confira na prévia e salve.',
    resultadoAlt: 'Resultado do ajuste',
    atualAlt: 'Imagem em uso',
    dicasTitulo: 'Dicas',
    fundo: {
      titulo: 'Imagem de fundo',
      padraoTexto: 'Foto do farol (padrão da Malgo)',
      dica1: 'Tamanho ideal: 1920 × 1080 px (proporção 16:9).',
      dica2: 'JPG ou WebP, até cerca de 500 KB.',
      dica3: 'Deixe o motivo principal no centro: no computador o formulário cobre a metade direita e, no celular, a parte de baixo.',
      dica4: 'A ferramenta de ajuste recorta em 16:9, reduz e comprime antes de enviar.',
    },
    logo: {
      titulo: 'Logo',
      padraoTexto: 'Logo da Malgo (padrão)',
      dica1: 'Tamanho ideal: cerca de 400 × 120 px; aparece com até 200 px de largura.',
      dica2: 'PNG ou WebP com fundo transparente.',
      dica3: 'Prefira a logo branca ou clara: ela aparece sobre a faixa escura da marca e, nos estilos de faixa clara (como o Cupertino), o login põe uma placa escura discreta sob ela. Confira na prévia.',
      dica4: 'A ferramenta de ajuste recorta (proporção de 1:1 a 5:1) e reduz antes de enviar.',
    },
    recorte: {
      area: 'Área de recorte',
      ajuda: 'Arraste a imagem ou use as setas (com Shift anda mais); a roda do mouse e as teclas + e - mudam o zoom.',
      zoom: 'Zoom',
      proporcao: 'Proporção (largura ÷ altura): {{valor}}',
      saida: 'Sai com {{largura}} × {{altura}} px',
      usar: 'Usar este recorte',
      cancelar: 'Cancelar',
      falhou: 'Não foi possível gerar a imagem neste navegador. Tente outro arquivo ou outro navegador.',
    },
    previa: {
      titulo: 'Prévia da tela de entrada',
      texto: 'Como fica no computador e no celular, nos temas claro e escuro, já com o que ainda não foi salvo.',
      computador: 'Computador',
      celular: 'Celular',
      claro: 'tema claro',
      escuro: 'tema escuro',
      legenda: '{{aparelho}}, {{tema}}',
      malgo: 'Estilo Malgo (padrão)',
      clara: 'Estilos com faixa clara (como o Cupertino)',
    },
  },
  usoIa: {
    ajuda: 'Tokens do Claude Code medidos no Mac (sessão principal e agentes), com o custo equivalente em preço de API pela tabela oficial da Anthropic. Não é a fatura do plano: serve para comparar dias, modelos e projetos.',
    granularidade: 'Agrupar por',
    por: { dia: 'Dia', semana: 'Semana', mes: 'Mês', ano: 'Ano' },
    navegar: 'Período',
    anterior: 'Período anterior',
    proximo: 'Próximo período',
    semanaDe: 'Semana de {{data}}',
    filtroProjeto: 'Projeto',
    filtroTipo: 'Tipo',
    todos: 'Todos',
    tipo: { principal: 'Sessão principal', agente: 'Agentes' },
    vazio: 'Nenhum uso recebido ainda',
    vazioTexto: 'Rode o medidor no Mac (node scripts/uso-ia/medir.mjs --enviar) para os números aparecerem aqui.',
    ind: {
      tokens: 'Tokens no período',
      mensagens: '{{n}} mensagens',
      usd: 'Custo em US$',
      semPreco: '{{n}} tokens de modelo sem preço na tabela',
      brl: 'Custo em R$',
      cotacao: 'Cotação: R$ {{valor}} por US$',
      variacao: 'Variação',
      contra: 'Contra {{periodo}}',
    },
    grafico: 'Evolução',
    graficoAria: 'Uso de IA de {{de}} a {{ate}}',
    graficoCusto: 'Custo em US$ por período; em destaque, o período escolhido.',
    graficoTokens: 'Tokens por período (nenhum modelo com preço na tabela); em destaque, o período escolhido.',
    porModelo: 'Modelo',
    porProjeto: 'Projeto',
    porTipo: 'Tipo',
    serie: 'Períodos',
    semUsoNoPeriodo: 'Nenhum uso neste período.',
    semPreco: 'Modelo sem preço na tabela oficial',
    participacaoTokens: 'Participação nos tokens: {{valor}}',
    col: {
      periodo: 'Período',
      mensagens: 'Mensagens',
      entrada: 'Entrada',
      cacheEscrito: 'Cache escrito',
      cacheLido: 'Cache lido',
      saida: 'Saída',
      total: 'Tokens',
      usd: 'US$',
      brl: 'R$',
      participacao: '% do período',
      variacao: 'Variação',
    },
    cotacao: {
      titulo: 'Cotação do dólar',
      rotulo: 'Reais por dólar',
      atualizada: 'Atualizada em {{quando}}',
      semCotacao: 'Sem cotação: informe para ver os valores em R$',
      salvar: 'Salvar cotação',
      salva: 'Cotação salva',
      invalida: 'Informe a cotação em reais por dólar, como 5,43',
    },
    rodape: 'Preços oficiais da Anthropic conferidos em {{data}}.',
    fonte: 'Tabela de preços',
    ultimoEnvio: 'último envio em {{quando}} (dados até {{dia}})',
  },
};

type Dic = typeof pt;

const en: Dic = {
  papelFabrica: { dono: 'IT', administrador: 'Administrator', gestor: 'Manager', operador: 'Operator', leitura: 'Read only' },
  nome: 'Admin panel',
  abas: { painel: 'Dashboard', modulos: 'Modules', tenants: 'Tenants and workspaces', usuarios: 'Users and access', auditoria: 'Audit', saude: 'Health', 'historico-telas': 'Screen history', erros: 'Error logs', 'tela-entrada': 'Sign-in screen', 'uso-ia': 'AI usage' },
  estadoJob: { pendente: 'pending', rodando: 'running', concluido: 'done', erro: 'failed', enviado: 'sent' },
  painel: {
    titulo: 'System health',
    postgres: 'PostgreSQL',
    redis: 'Redis',
    worker: 'Worker',
    versao: 'Version live',
    online: 'Online',
    fora: 'Down',
    ativo: 'Active',
    parado: 'Stopped',
    ultimoSinal: 'Last signal {{quando}}',
    semSinal: 'No worker signal',
    jobs24h: 'Jobs in the last 24 hours',
    jobsEstado: { pendente: 'Pending', rodando: 'Running', concluido: 'Done', erro: 'Failed' },
    semJobs: 'No jobs in the last 24 hours.',
    fila: 'Delivery queue (outbox) in the last 24 hours',
    erros: 'Recent errors',
    errosJobs: 'Failed jobs',
    errosWebhooks: 'Failed webhooks',
    semErros: 'No recent errors. All good here.',
    tentativas_one: '{{count}} attempt', tentativas_other: '{{count}} attempts',
    atualizar: 'Refresh',
  },
  modulos: {
    instalado: 'Installed',
    naoInstalado: 'Not installed',
    fixo: 'Fixed',
    versao: 'Version {{v}}',
    dependeDe: 'Depends on',
    dependentes: 'Dependents',
    usaSeInstalado: 'Uses, if installed',
    nenhum: 'None',
    instalar: 'Install',
    desinstalar: 'Uninstall',
    instaladoEm: 'Installed on {{data}}',
    confirmarInstalar: 'Install {{nome}}?',
    instalarTambem: 'These will also be installed: {{lista}}.',
    instalarSem: 'No extra dependencies to install.',
    confirmarDesinstalar: 'Uninstall {{nome}}?',
    desinstalarTexto: 'Menus and routes disappear for the whole tenant, but the data is kept. You can install it again anytime.',
    bloqueado: 'Uninstall first: {{lista}}.',
    fixoAviso: 'Fixed module, it cannot be uninstalled.',
    okInstalado: 'Installed: {{lista}}',
    okJaInstalado: 'The module was already installed',
    okDesinstalado: '{{nome}} uninstalled',
    ligadoNoWorkspace: 'On in this workspace',
    desligadoNoWorkspace: 'Off in this workspace',
    porWorkspace: 'Per workspace',
    porWorkspaceAjuda: 'Optional module: starts off and only shows in the workspace that turns it on (the data is kept).',
    ligarNoWorkspace: 'Turn on in this workspace',
    desligarNoWorkspace: 'Turn off in this workspace',
    confirmarLigar: 'Turn on {{nome}} in this workspace?',
    ligarTexto: 'The module menus, routes, MCP tools and indicators start showing in {{workspace}}, for all companies.',
    confirmarDesligar: 'Turn off {{nome}} in this workspace?',
    desligarTexto: 'The module menus, routes, MCP tools and indicators disappear from {{workspace}}. The data is kept and comes back when you turn it on again.',
    okLigado: '{{nome}} turned on in this workspace',
    okDesligado: '{{nome}} turned off in this workspace',
    menu: 'Menu',
    abas: 'Tabs',
    permissoes_one: '{{count}} permission', permissoes_other: '{{count}} permissions',
    vazio: 'The module catalog is empty.',
  },
  tenants: {
    workspaces: 'Tenant workspaces',
    novoWorkspace: 'New workspace',
    nome: 'Name',
    slug: 'Identifier',
    slugAjuda: 'Lowercase letters, numbers and hyphen. If empty, it is generated from the name.',
    sandbox: 'Sandbox',
    sandboxAjuda: 'Test environment, separate from real data.',
    atual: 'Current',
    membros_one: '{{count}} member', membros_other: '{{count}} members',
    renomear: 'Rename',
    marcarSandbox: 'Mark as sandbox',
    desmarcarSandbox: 'Remove sandbox',
    editarWorkspace: 'Edit workspace',
    excluirWorkspace: 'Delete the workspace {{nome}}?',
    excluirWorkspaceTexto: 'Nothing is erased: the workspace is archived with everything in it and nobody can enter it anymore (its sessions and API keys stop at once). Only IT in a production workspace can delete, and never the workspace in use.',
    excluirTenant: 'Delete the tenant {{nome}}?',
    excluirTenantTexto: 'Nothing is erased: the tenant is cancelled and archived with all its workspaces and data, and nobody from it can sign in anymore. It leaves this list. Your own tenant cannot be deleted.',
    workspaceCriado: 'Workspace created',
    vazioWorkspaces: 'No workspaces found.',
    plataforma: 'Platform',
    plataformaTexto: 'All tenants on the platform. This section only shows for platform administrators.',
    novoTenant: 'New tenant',
    tenant: 'Tenant',
    plano: 'Plan',
    creditosQtd_one: '{{valor}} credit', creditosQtd_other: '{{valor}} credits',
    creditos: 'Credits',
    estado: 'Status',
    estados: { ativo: 'Active', suspenso: 'Suspended', cancelado: 'Canceled' },
    qtdWorkspaces: 'Workspaces',
    qtdUsuarios: 'Users',
    criadoEm: 'Created on',
    donoNome: 'IT person name',
    donoEmail: 'IT person e-mail',
    workspaceInicial: 'First workspace name',
    conviteAviso: 'The owner gets an e-mail with a link to set a password and sign in. The link is valid for 72 hours.',
    tenantCriado: 'Tenant created and invitation sent',
    editarTenant: 'Edit {{nome}}',
    vazioTenants: 'No tenants yet.',
    semAcesso: 'Only platform administrators see tenants.',
  },
  usuarios: {
    subabas: { membros: 'Members', convites: 'Invitations', papeis: 'Roles', pedidos: 'Requests' },
    pedidos: {
      texto: 'Requests to change the e-mail or the username made by people in My account. Approving the username changes it right away; approving the e-mail sends the confirmation link to the new address.',
      pendentes: 'Pending requests',
      nenhumPendente: 'No pending requests.',
      recentes: 'Decided in the last 30 days',
      vazioTitulo: 'No requests',
      vazioTexto: 'When someone asks to change the e-mail or the username in My account, the request shows up here and you get a notice.',
      atual: { email: 'Current e-mail', usuario: 'Current username' },
      novo: { email: 'Requested e-mail', usuario: 'Requested username' },
      semEmail: 'No e-mail',
      aprovar: 'Approve',
      recusar: 'Decline',
      cancelar: 'Cancel',
      status: { aprovado: 'Approved', recusado: 'Declined' },
      decidido: 'Decided by {{quem}} on {{quando}}.',
      motivo: 'Reason: {{motivo}}',
      aprovadoEmail: 'Request approved: we sent the confirmation link to the new e-mail',
      aprovadoUsuario: 'Request approved: the username has already changed',
      recusado: 'Request declined',
      recusarTitulo: 'Decline the request',
      motivoCampo: 'Reason (optional)',
      motivoAjuda: 'The person reads the reason in My account.',
    },
    arvore: {
      titulo: 'Access by subsystem, page and action',
      ajudaSemSubsistemas: 'Subsystems are turned off in this workspace: the default split works as a guide. Check the group to grant all its pages and actions; open it to uncheck pages and actions (actions belong to the module and apply to all of its pages).',
      comuns: 'Common to all',
      outras: 'Other permissions',
      contagem: '{{marcadas}} of {{total}} pages',
      acoesDoModulo: 'Actions of the {{modulo}} module (apply to all of its pages)',
      excecao: 'exception',
      semConceder: 'You do not have this action to grant',
      ajuda: 'Check the subsystem the role works in: it shows only the pages of that subsystem, and only it stays open and checked. Open it to uncheck pages and, in each page, actions. Actions belong to the module and apply to all of its pages; a page that is in more than one subsystem is a single page (checking it here opens it wherever it appears).',
      tambemEm: 'also in: {{lista}}',
      resumo: {
        papel: 'This role opens',
        pessoa: 'This person opens',
        voce: 'You open',
        paginas_one: '{{count}} page',
        paginas_other: '{{count}} pages',
        comSubsistemas: '{{sujeito}}: {{paginas}} in {{lista}}',
        semSubsistemas: '{{sujeito}}: {{paginas}}',
        papelNenhuma: 'This role does not open any page yet.',
        pessoaNenhuma: 'This person does not open any page yet.',
        voceNenhuma: 'You do not open any page yet.',
      },
    },
    acessoPersonalizado: 'Custom access',
    filtroAcesso: 'Filter by access',
    acessoTodos: 'Any access',
    acessoPessoa: {
      titulo: 'This person\'s access',
      ajuda: 'Starts from the sum of the roles. Check or uncheck to grant or remove only for this person (exception, recorded in the audit log). Prefer solving it with roles.',
      desativado: 'Member deactivated: access is read-only; reactivate to edit',
      salvar: 'Save access',
      voltar: 'Back to roles only',
      salvo: 'Person\'s access saved',
      retiradasJunto: 'Removed along with the granted action (you cannot open these pages): {{paginas}}.',
    },
    convidar: 'Invite',
    novoPapel: 'New role',
    nome: 'Name',
    email: 'E-mail',
    papelUnico: 'Role',
    papeis: 'Roles',
    estado: 'Status',
    ativo: 'Active',
    inativo: 'Deactivated',
    ultimoAcesso: 'Last access',
    formasAcesso: 'Sign-in',
    nunca: 'Never signed in',
    desde: 'Member since',
    empresas: 'Allowed companies',
    empresasPelaFicha: "This person's companies follow the verticals on their employee record (People): when the verticals change there, this list follows.", 
    empresasAjuda: 'With none selected, the user accesses every company in the workspace. With companies selected, the user only sees their data (finance, receivables and payables, purchasing and payroll) and only picks among them in the company filter at the top. IT always sees all of them. Consolidated reports and the Group dashboard depend on the role permission for the consolidated view or on the exception below.',
    empresasVeTodasRestrito: 'This user has no company list: they see every company in the workspace. Only someone who sees every company can change their list.',
    empresasOutras: 'They also have companies you cannot see; those stay as they are.',
    empresasAjudaRestrito: 'With companies selected, the user only sees their data (finance, receivables and payables, purchasing and payroll) and only picks among them in the company filter at the top. Since you do not see every company, the list must keep at least one selected, and the companies you cannot see stay as they are. Consolidated reports and the Group dashboard depend on the role permission for the consolidated view or on the exception below.',
    semEmpresas: 'No companies registered in this workspace.',
    salvarPapeis: 'Save roles',
    salvarEmpresas: 'Save companies',
    consolidado: 'See the consolidated view of the companies (reports and Group dashboard), as an exception',
    modoSimples: 'Simple mode',
    modoSimplesLigar: 'Turn on simple mode for this person',
    modoSimplesAjuda: 'Hides the advanced tabs and fields. The person can also turn it on or off in My account; no permission changes.',
    modoSimplesSalvar: 'Save simple mode',
    estilo: 'Interface style',
    estiloAjuda: 'Fixes this person\'s style in this workspace: they cannot change it. When not fixed, their own choice or the workspace default applies.',
    estiloSeguir: 'Do not fix (follow the person\'s choice or the workspace default)',
    estiloSalvar: 'Save style',
    estiloFixado: 'Fixed style: {{nome}}',
    definirEstilo: 'Set style',
    estiloLoteTitulo: 'Set the style of {{count}} person(s)',
    estiloLoteSeguir: 'Do not fix (follow the person\'s choice or the workspace default)',
    estiloLoteAplicar: 'Apply',
    selecionados_one: '{{count}} selected',
    selecionados_other: '{{count}} selected',
    limparSelecao: 'Clear selection',
    selecionar: 'Select {{nome}}',
    estiloAplicado: 'Style set for {{count}} person(s)',
    estiloParcial: 'Style set for {{feitos}} of {{total}} people; the others are still selected. {{erro}}',
    consolidadoAjuda: 'Grants only this person the combined view of the allowed companies, without changing the role.',
    promoverDono: 'Promote to IT',
    promoverTitulo: 'Promote {{nome}} to IT?',
    promoverTexto: 'The IT role has full access to the workspace and can promote others. Only IT can make this promotion.',
    desativar: 'Deactivate',
    reativar: 'Reactivate',
    desativarTitulo: 'Deactivate {{nome}}?',
    remover: 'Remove from workspace',
    removido: 'Member removed from the workspace',
    removerTitulo: 'Remove {{nome}} from the workspace?',
    removerTexto: 'The person leaves the member list and can be invited again. Nothing is deleted: the audit log and the history of what they did remain.',
    desativarTexto: 'The person loses access to this workspace right away. Their history is kept and you can reactivate later.',
    autoDesativacao: 'You cannot deactivate yourself.',
    voce: 'you',
    papelDonoAviso: 'To give someone the IT role use the Promote to IT button.',
    vazioMembros: 'No members found.',
    filtroSituacao: 'Status',
    todos: 'All',
    soAtivos: 'Active',
    soInativos: 'Deactivated',
    convite: {
      titulo: 'Invite to the workspace',
      tipo: 'Type',
      tipos: { funcionario: 'Employee', parceiro: 'Client or partner', convidado: 'Guest' },
      tipoAjuda: {
        funcionario: 'Access to the system linked to the People record; the profile comes from the job role.',
        parceiro: 'Access to the Client portal, with no system role.',
        convidado: 'Someone who is not an employee (external accountant, consultant): only the role.',
      },
      origem: 'Employee',
      origens: { existente: 'Already in People, without access', novo: 'Register now (only name, email, department, job role and company)' },
      funcionario: 'Employee without access',
      funcionarioAjuda: 'Only the ones still without a user or invitation appear.',
      acesso: 'How the person will sign in',
      acessos: { email: 'Invitation by e-mail', usuario: 'Username and temporary password (no e-mail)' },
      acessoAjuda: {
        email: 'The invitation link goes by e-mail and the person sets the password. It can be the personal e-mail: they change it to the company one later, in My account, without losing anything.',
        usuario: 'For someone without an e-mail yet: you hand over the username and the temporary password, valid for 72 hours and changed at the first sign in. Password recovery stays with the administrator.',
      },
      emailAcesso: 'Sign-in e-mail (if not the one in the record)',
      emailAcessoAjuda: 'E.g. the personal e-mail, before the company one. The contact e-mail in the record stays the same.',
      emailContato: 'Contact e-mail (optional)',
      usuario: 'Username',
      usuarioAjuda: 'Blank: {{exemplo}} (made from the name; if it exists, a number is added). No "@" and no accents.',
      criarAcesso: 'Create access',
      entrarEmail: 'Sign in with e-mail',
      entrarUsuario: 'Sign in with username',
      formasAjuda: 'Tick one or both. With an e-mail, the invitation carries the link for the person to create their own password (and the username, if ticked). Username only and no e-mail: the temporary password shows once for you to hand over.',
      formaObrigatoria: 'Choose at least one sign-in method',
      emailFichaAjuda: 'Blank: the e-mail in the record. It can be another one (the personal one, for example).',
      emailOpcionalAjuda: 'Optional when only the username is ticked: with an e-mail, the person gets the username and the link to create the password.',
      empresa: 'Company',
      empresaAtual: 'The current company',
      papelFuncao: 'Access role',
      papelFuncaoAjuda: 'Access comes from the role. The job role suggests one (already filled in); change it if needed. Changing the job role later does not change access.',
      novoAjuda: 'CPF and hire date stay to complete in the record ("Details to complete" badge).',
      parceiro: 'Client or partner',
      papelPortal: 'Role in the portal',
      semPortal: 'The Client portal is not installed in this workspace.',
      semPermissaoPortal: 'You do not have the portal access permission.',
      semPessoas: 'The People module is not installed in this workspace.',
      semPermissaoPessoas: 'You do not have the permission to edit in People.',
      enviadoPortal: 'Portal invitation sent',
      enviar: 'Send invitation',
      enviado: 'Invitation sent',
      expiraEm: 'Expires {{quando}}',
      expirado: 'Expired',
      reenviar: 'Resend',
      cancelar: 'Cancel invitation',
      cancelarTitulo: 'Cancel the invitation for {{email}}?',
      cancelarTexto: 'The link already sent stops working.',
      reenviado: 'Invitation resent with a new link',
      cancelado: 'Invitation canceled',
      convidadoPor: 'Invited by {{nome}}',
      vazio: 'No pending invitations.',
      nomeAjuda: 'Optional. The person can adjust it when accepting.',
      editar: 'Edit',
      editarTitulo: 'Edit invitation',
      editado: 'Invitation updated. The link already sent still works.',
      editadoNovoLink: 'Invitation sent to the new email. The previous link no longer opens.',
      emailTrocaAviso: 'Changing the email cancels this invitation and sends a new link to the new address; the current link stops opening. Changing anything else keeps the link and the deadline.',
      empresasConvite: 'Companies',
      empresasConviteAjuda: 'None checked: all the companies you see.',
      salvar: 'Save invitation',
      detalheTitulo: 'Invitation for {{nome}}',
      detalheSemFicha: 'This person has no record in the system.',
      criarFicha: 'Create record',
      criarFichaAjuda: 'Creates the person in Records > People and companies with the invitation name and email.',
      fichaCriada: 'Record created',
      abrirFicha: 'Open the record of {{nome}}',
      verConvite: 'See the invitation for {{nome}}',
    },
    papel: {
      deFabrica: 'Built in',
      personalizado: 'Custom',
      membros_one: '{{count}} member', membros_other: '{{count}} members',
      permissoes_one: '{{count}} permission', permissoes_other: '{{count}} permissions',
      imutavel: 'Built-in roles cannot be edited. Create a custom role to adjust permissions.',
      matriz: 'Permissions by module',
      marcarTodas: 'Select all',
      nucleo: 'Core',
      nomeLabel: 'Role name',
      criarTitulo: 'New custom role',
      duplicar: 'Duplicate',
      duplicarTitulo: 'Duplicate the role {{nome}}',
      duplicarTexto: 'The new role starts with the permissions, assistant levels and default notifications of {{nome}}. Adjust anything before creating it.',
      nomeCopia: '{{nome}} (copy)',
      copiaParcial: 'Role created, but the assistant levels or default notifications were not copied: {{erro}}',
      criado: 'Role created',
      excluir: 'Delete role',
      excluirTitulo: 'Delete the role {{nome}}?',
      excluirTexto: 'Only roles with no members and no pending invitations can be deleted.',
      excluido: 'Role deleted',
      vazio: 'No roles found.',
      semModulos: 'No module with permissions is installed.',
    },
    conta: {
      titulo: 'Account access',
      semEmail: 'No e-mail (signs in with the username)',
      usuarioRotulo: 'Username: {{usuario}}',
      emailTexto: 'The confirmation link goes to the new e-mail; the change only takes effect after it and the current e-mail gets a notice. History, roles and two-step verification stay. Not available for someone who is also a member of another workspace where you are not IT.',
      emailNovo: 'New e-mail',
      trocarEmail: 'Change e-mail',
      adicionarEmail: 'Add e-mail',
      emailEnviado: 'If the address can be used, the confirmation link was sent to it.',
      novaSenha: 'New temporary password',
      novaSenhaTexto: 'For the account without e-mail that lost the password: recovery is with the administrator.',
      novaSenhaConfirmar: 'The current password and the open sessions of the person stop working. The new password shows once for you to hand over; it is valid for 72 hours and changed at the first sign in.',
    },
    acessoCriado: {
      titulo: 'Access created',
      texto: 'Hand these details to the person. The temporary password shows only now, is valid until {{quando}} and will be changed at the first sign in.',
      usuario: 'Username',
      senha: 'Temporary password',
      copiar: 'Copy the details',
      copiado: 'Copied',
      fechar: 'I handed them over',
    },
    mfaTitulo: 'Two-step verification', mfaResetar: 'Reset two-step verification', mfaResetarTexto: 'Use it when the person lost the phone and the backup codes. The current app stops working and, if the role requires it, they set it up again at the next sign in.', mfaResetado: 'Two-step verification reset',
    teste: { titulo: 'Test user', selo: 'Test', texto: 'Demo account with no sign in of its own: whoever has "Simulate test user" enters it from the profile menu. Only an account that never signed in can become a test user. Marking it removes the password, ends the sessions and revokes the account API keys, assistants and connections.', seloSimulacao: 'Simulation', textoSimulacao: 'Simulation user of this role: created with the role and removed with it, it has no sign in of its own and only the platform administrator sees and simulates it. Its access changes here like anyone else (role, companies and exceptions), except IT.', marcar: 'Mark as test user', desmarcar: 'Stop being a test user', marcado: 'Marked as test user', desmarcado: 'No longer a test user', soSemEmail: 'Only the account without email (sign in by username) can become a test user.' },
    acaoPermissao: {
      consolidado: 'Consolidated view of the companies (reports and Group dashboard)',
      erros: { ver: 'View the error log' },
      adm: { usar: 'Use ADM' },
      subsistemas: { configurar: 'Configure subsystems' },
      erp: { usar: 'Use ERP' },
      crm: { usar: 'Use CRM' },
      suporte: { usar: 'Use Support' },
      automacoes: { usar: 'Use Automations' },
      rh: { usar: 'Use HR' },
      ver: 'View',
      criar: 'Create',
      editar: 'Edit',
      excluir: 'Delete',
      importar: 'Import',
      mesclar: 'Merge',
      modulos: 'Modules',
      usuarios: 'Users',
      papeis: 'Roles',
      auditoria: 'Audit',
      tenants: 'Tenants',
      fechar: 'Close',
      confidencial: 'Salary, documents and personal data',
      campos_telas: 'Configure screen fields',
      aprovar: 'Approve',
      salvar: 'Save',
      compartilhar: 'Share',
      agendar: 'Schedule delivery',
      arquivos: 'Manage the File center',
      // FUN 2026-10-15 (U7): permissões do módulo Automações por área.
      ver_todas: 'See all areas',
      area_fiscal: 'Tax area',
      area_dp: 'Payroll area',
      area_bpo: 'BPO area',
      area_legalizacao: 'Corporate area',
      area_ti: 'IT area',
      simular_usuario: 'Simulate test user',
    },
    // Val5 (29/10): rótulo próprio da ação de um módulo (`<modulo>.<acao>`), quando o genérico por ação não diz o que ela faz.
    acaoModulo: {
      agenda: { cancelar: 'Cancel and reschedule appointments', bloquear: 'Block time slots' },
      assinaturas: { faturar: 'Bill contract', pausar: 'Pause and resume contract', configurar: 'Configure subscriptions' },
      ausencias: { exportar: 'Export absences' },
      automacoes: { publicar: 'Publish flow', disparar: 'Send broadcast', configurar: 'Configure automations' },
      cadastros: { exportar: 'Export contacts and companies', arquivar: 'Archive and unarchive' },
      compras: { enviar: 'Send order to supplier' },
      configuracoes: { empresas: 'Manage group companies', campos: 'Manage custom fields' },
      conversas: { configurar: 'Configure channels and support', templates: 'Manage WhatsApp templates' },
      documentos: { enviar: 'Send for signature', cancelar: 'Cancel signature' },
      estoque: { importar: 'Import products' },
      folha: { configurar: 'Configure payroll' },
      pessoas: { importar: 'Import employees', desligar: 'Terminate employee', convidar: 'Invite to the system', configurar: 'Configure people structure' },
      pipeline: { exportar: 'Export deals and tasks', ganhar_perder: 'Mark as won or lost (and reopen)', configurar: 'Configure the CRM', metas: 'Set targets and teams', enviar: 'Send e-mail and proposal', em_massa: 'Bulk actions' },
      relatorios: { publicar_portal: 'Publish report on the Portal' },
      tarefas: { configurar: 'Configure boards and projects' },
      treinamento: { atribuir: 'Assign training', acompanhar: 'Track the team progress' },
    },
  },
  erros: {
    intro: 'When an action fails, the system logs what the person was trying to do, the error and what was filled in (no passwords or documents). The team, or a support AI, can find it, fix it and redo the action before the person needs to report it. Each new error also shows up in Notifications.',
    quando: 'When',
    pessoa: 'Person',
    acao: 'Action attempted',
    tela: 'Screen',
    erro: 'Error',
    situacao: 'Status',
    status: { novo: 'New', analise: 'Under review', corrigido: 'Fixed' },
    filtros: { abertos: 'Open', novo: 'New', analise: 'Under review', corrigido: 'Fixed', todos: 'All' },
    vazio: 'No errors logged',
    vazioFiltro: 'No errors in this filter',
    vazioTexto: 'To see how it works, use "Simulate error".',
    simular: 'Simulate error',
    feedback: 'Feedback',
    acaoFeedback: 'Give us feedback',
    gravado: { botao: 'Button', link: 'Link', opcao: 'Option', secao: 'Section', campo: 'Field', carregarTela: 'Load the screen', foraDeClique: 'Outside a click', simularErro: 'Simulate error (test)', abrirTela: 'Open the screen', janela: 'window' },
    textoFeedback: 'What the person suggested',
    erroDeTeste: 'Test error: the button simulated a failure while saving',
    detalhe: 'Logged error',
    acaoTentava: 'What the person was trying to do',
    preenchido: 'What was filled in',
    nadaPreenchido: 'No open fields.',
    navegador: 'Browser',
    notas: 'Team notes',
    notaPlaceholder: 'Cause, fix, version...',
    notaSalva: 'Note saved',
    copiarRelato: 'Copy report for the AI',
    copiado: 'Report copied',
    naoCopiou: 'Could not copy. Select the text and copy it.',
    executarDeNovo: 'Run the action again',
    executou: 'Action run again',
    abrirTela: 'Open the screen',
    soNaMesmaAba: 'Running again only works in the same browser tab where the error happened. Elsewhere, "Open the screen" takes you to the same place.',
    emAnalise: 'Under review',
    marcarCorrigido: 'Mark as fixed',
    reabrir: 'Reopen',
    mudou: { novo: 'Error reopened', analise: 'Error under review', corrigido: 'Error marked as fixed' },
    dadosOcultos: 'What was filled in is hidden: the error belongs to a company or a module you cannot see.',
    relato: {
      intro: 'Error on a MalgoOS screen. Analyze the cause, propose the code fix and explain how to redo what the person was trying to do.',
      quando: 'When',
      pessoa: 'Person',
      acao: 'Action attempted',
      tela: 'Screen',
      origem: 'Source',
      erro: 'Error',
      requestId: 'request_id (API log)',
      pilha: 'Stack',
      semPilha: '(no stack)',
      dados: 'Data filled in at the time',
      dadosOcultos: '(hidden for whoever copied)',
      navegador: 'Browser',
    },
  },
  auditoria: {
    data: 'Date',
    usuario: 'User',
    acao: 'Action',
    entidade: 'Entity',
    registro: 'Record',
    ip: 'IP',
    requisicao: 'Request',
    todosUsuarios: 'All users',
    todasEntidades: 'All entities',
    todasAcoes: 'All actions',
    de: 'From',
    ate: 'To',
    detalhe: 'Record detail',
    mudancas: 'Changes',
    campo: 'Field',
    antes: 'Before',
    depois: 'After',
    adicionado: 'Added',
    removido: 'Removed',
    alterado: 'Changed',
    semMudancas: 'No difference recorded for this event.',
    verJson: 'See full data',
    ocultadoConteudo: 'The content of this record was hidden by your permission: you lack access to the module that owns the data.',
    ocultadoCampos: 'Part of the content was hidden by your permission.',
    sistema: 'System',
    chaveApi: 'API key',
    simuladoPor: 'simulated by {{nome}}',
    vazio: 'No records for the chosen filters.',
    limpar: 'Clear filters',
  },
  saude: {
    versoes: 'Versions',
    aplicacao: 'Application',
    node: 'Node.js',
    postgres: 'PostgreSQL',
    worker: 'Worker',
    sinal: 'Worker signal',
    modulos: 'Catalog modules',
    fila: 'Delivery queue (outbox)',
    filaAgora: 'Pending across the whole database',
    filaMaisAntigo: 'oldest {{quando}}',
    filaVazia: 'Nothing pending. The queue is up to date.',
    fila24h: 'Last 24 hours',
    jobsPorTipo: 'Jobs by type in the last 24 hours',
    tipo: 'Type',
    estado: 'Status',
    total: 'Total',
    erros: 'Failed jobs',
    semErros: 'No errors recorded.',
    tentativas_one: '{{count}} attempt', tentativas_other: '{{count}} attempts',
    webhooks: 'Failed webhooks',
    eventosErro: 'Received events with errors',
    conector: 'Connector',
    resposta: 'Response',
    atualizar: 'Refresh',
    semSinal: 'No signal',
  },  historico: {
    intro_one: '{{count}} screen compared, before and after. Click an image to enlarge it.',
    intro_other: '{{count}} screens compared, before and after. Click an image to enlarge it.',
    geradoEm: 'Catalog from {{quando}}.',
    antes: 'Before',
    depois: 'After',
    celularAntes: 'Mobile · before',
    celularDepois: 'Mobile · after',
    semAntes: 'New, no before',
    semCaptura: 'No capture',
    imagem: '{{titulo}}: {{rotulo}}',
    imagemN: '{{titulo}}: {{rotulo}} ({{n}} of {{total}})',
    ampliar: 'Enlarge {{nome}}',
    oculta: 'Image hidden in discreet mode',
    vazioTitulo: 'Screen history not published yet',
    vazioTexto: 'The images live on the server, outside the system. Publish the catalog with the operations guide for them to show up here.',
    vazioSemItens: 'The published catalog has no screens.',
  },
  telaEntrada: {
    intro: 'The logo and background image of the sign-in and sign-out screens apply to every workspace, because the screen appears before sign-in. Only the platform administrator can change them.',
    textos: {
      cartao: 'Screen texts',
      ajuda: 'The tagline, title and subtitle shown next to the form on desktop. Leave blank to use the default text (the gray one inside the field), which follows the viewer\'s language; text you write applies to every language.',
      kicker: 'Tagline (above the title)',
      titulo: 'Title',
      subtitulo: 'Subtitle',
      limite: '{{usados}} of {{max}} characters',
      salvar: 'Save texts',
      voltarPadrao: 'Back to default texts',
      salvos: 'Sign-in screen texts saved.',
      restaurados: 'Default texts are back on the sign-in screen.',
    },
    padrao: 'Default',
    personalizada: 'Custom',
    atualizadaEm: 'Changed on {{quando}}',
    escolher: 'Choose image',
    trocar: 'Change image',
    salvar: 'Save',
    descartar: 'Discard',
    voltarPadrao: 'Restore default',
    confirmarPadraoTitulo: 'Restore the default?',
    confirmarPadraoFundo: 'The sign-in screen will show the lighthouse photo again for everyone.',
    confirmarPadraoLogo: 'The sign-in screen will show the Malgo logo again for everyone.',
    salva: 'Sign-in screen updated',
    processando: 'Uploading and processing the image on the server; it may take up to a minute.',
    restaurada: 'Default restored',
    tipoInvalido: 'Choose a PNG, JPG or WebP image. SVG and other formats are not accepted.',
    grandeDemais: 'File larger than 20 MB. Choose a smaller image.',
    naoAbriu: 'This image could not be opened. Choose another file.',
    resultado: 'Adjusted result: {{largura}} × {{altura}} px, {{tamanho}}. Check the preview and save.',
    resultadoAlt: 'Adjusted result',
    atualAlt: 'Image in use',
    dicasTitulo: 'Tips',
    fundo: {
      titulo: 'Background image',
      padraoTexto: 'Lighthouse photo (Malgo default)',
      dica1: 'Ideal size: 1920 × 1080 px (16:9 ratio).',
      dica2: 'JPG or WebP, up to about 500 KB.',
      dica3: 'Keep the main subject in the center: on a computer the form covers the right half and, on a phone, the bottom part.',
      dica4: 'The adjustment tool crops to 16:9, resizes and compresses before uploading.',
    },
    logo: {
      titulo: 'Logo',
      padraoTexto: 'Malgo logo (default)',
      dica1: 'Ideal size: about 400 × 120 px; shown up to 200 px wide.',
      dica2: 'PNG or WebP with a transparent background.',
      dica3: 'Prefer a white or light logo: it appears on the dark brand strip and, in styles with a light strip (such as Cupertino), the sign-in screen puts a subtle dark plate under it. Check the preview.',
      dica4: 'The adjustment tool crops (ratio from 1:1 to 5:1) and resizes before uploading.',
    },
    recorte: {
      area: 'Crop area',
      ajuda: 'Drag the image or use the arrow keys (Shift moves further); the mouse wheel and the + and - keys change the zoom.',
      zoom: 'Zoom',
      proporcao: 'Ratio (width ÷ height): {{valor}}',
      saida: 'Output: {{largura}} × {{altura}} px',
      usar: 'Use this crop',
      cancelar: 'Cancel',
      falhou: 'The image could not be generated in this browser. Try another file or another browser.',
    },
    previa: {
      titulo: 'Sign-in screen preview',
      texto: 'How it looks on a computer and on a phone, in the light and dark themes, including what has not been saved yet.',
      computador: 'Computer',
      celular: 'Phone',
      claro: 'light theme',
      escuro: 'dark theme',
      legenda: '{{aparelho}}, {{tema}}',
      malgo: 'Malgo style (default)',
      clara: 'Styles with a light strip (such as Cupertino)',
    },
  },
  usoIa: {
    ajuda: 'Claude Code tokens measured on the Mac (main session and agents), with the equivalent cost at API prices from Anthropic’s official price list. This is not the plan invoice: use it to compare days, models and projects.',
    granularidade: 'Group by',
    por: { dia: 'Day', semana: 'Week', mes: 'Month', ano: 'Year' },
    navegar: 'Period',
    anterior: 'Previous period',
    proximo: 'Next period',
    semanaDe: 'Week of {{data}}',
    filtroProjeto: 'Project',
    filtroTipo: 'Type',
    todos: 'All',
    tipo: { principal: 'Main session', agente: 'Agents' },
    vazio: 'No usage received yet',
    vazioTexto: 'Run the meter on the Mac (node scripts/uso-ia/medir.mjs --enviar) for the numbers to show up here.',
    ind: {
      tokens: 'Tokens in the period',
      mensagens: '{{n}} messages',
      usd: 'Cost in US$',
      semPreco: '{{n}} tokens from models without a listed price',
      brl: 'Cost in R$',
      cotacao: 'Rate: R$ {{valor}} per US$',
      variacao: 'Change',
      contra: 'Versus {{periodo}}',
    },
    grafico: 'Trend',
    graficoAria: 'AI usage from {{de}} to {{ate}}',
    graficoCusto: 'Cost in US$ per period; the chosen period is highlighted.',
    graficoTokens: 'Tokens per period (no model with a listed price); the chosen period is highlighted.',
    porModelo: 'Model',
    porProjeto: 'Project',
    porTipo: 'Type',
    serie: 'Periods',
    semUsoNoPeriodo: 'No usage in this period.',
    semPreco: 'Model without a price in the official list',
    participacaoTokens: 'Share of tokens: {{valor}}',
    col: {
      periodo: 'Period',
      mensagens: 'Messages',
      entrada: 'Input',
      cacheEscrito: 'Cache written',
      cacheLido: 'Cache read',
      saida: 'Output',
      total: 'Tokens',
      usd: 'US$',
      brl: 'R$',
      participacao: '% of period',
      variacao: 'Change',
    },
    cotacao: {
      titulo: 'Dollar exchange rate',
      rotulo: 'Reais per dollar',
      atualizada: 'Updated on {{quando}}',
      semCotacao: 'No rate set: enter one to see the amounts in R$',
      salvar: 'Save rate',
      salva: 'Rate saved',
      invalida: 'Enter the rate in reais per dollar, like 5.43',
    },
    rodape: 'Anthropic’s official prices checked on {{data}}.',
    fonte: 'Price list',
    ultimoEnvio: 'last upload on {{quando}} (data up to {{dia}})',
  },
};

const es: Dic = {
  papelFabrica: { dono: 'TI', administrador: 'Administrador', gestor: 'Gestor', operador: 'Operador', leitura: 'Solo lectura' },
  nome: 'Panel admin',
  abas: { painel: 'Panel', modulos: 'Módulos', tenants: 'Tenants y workspaces', usuarios: 'Usuarios y accesos', auditoria: 'Auditoría', saude: 'Salud', 'historico-telas': 'Historial de pantallas', erros: 'Registros de errores', 'tela-entrada': 'Pantalla de entrada', 'uso-ia': 'Uso de IA' },
  estadoJob: { pendente: 'pendiente', rodando: 'en curso', concluido: 'concluido', erro: 'error', enviado: 'enviado' },
  painel: {
    titulo: 'Salud del sistema',
    postgres: 'PostgreSQL',
    redis: 'Redis',
    worker: 'Worker',
    versao: 'Versión en línea',
    online: 'En línea',
    fora: 'Caído',
    ativo: 'Activo',
    parado: 'Detenido',
    ultimoSinal: 'Última señal {{quando}}',
    semSinal: 'Sin señal del worker',
    jobs24h: 'Jobs en las últimas 24 horas',
    jobsEstado: { pendente: 'Pendientes', rodando: 'En curso', concluido: 'Concluidos', erro: 'Con error' },
    semJobs: 'Ningún job en las últimas 24 horas.',
    fila: 'Cola de envío (outbox) en las últimas 24 horas',
    erros: 'Errores recientes',
    errosJobs: 'Jobs con error',
    errosWebhooks: 'Webhooks que fallaron',
    semErros: 'Sin errores recientes. Todo bien por aquí.',
    tentativas_one: '{{count}} intento', tentativas_other: '{{count}} intentos',
    atualizar: 'Actualizar',
  },
  modulos: {
    instalado: 'Instalado',
    naoInstalado: 'No instalado',
    fixo: 'Fijo',
    versao: 'Versión {{v}}',
    dependeDe: 'Depende de',
    dependentes: 'Dependientes',
    usaSeInstalado: 'Usa, si está instalado',
    nenhum: 'Ninguno',
    instalar: 'Instalar',
    desinstalar: 'Desinstalar',
    instaladoEm: 'Instalado el {{data}}',
    confirmarInstalar: '¿Instalar {{nome}}?',
    instalarTambem: 'También se instalarán: {{lista}}.',
    instalarSem: 'Sin dependencias extra por instalar.',
    confirmarDesinstalar: '¿Desinstalar {{nome}}?',
    desinstalarTexto: 'Los menús y rutas desaparecen para todo el tenant, pero los datos se conservan. Puedes instalarlo de nuevo cuando quieras.',
    bloqueado: 'Desinstala antes: {{lista}}.',
    fixoAviso: 'Módulo fijo, no se puede desinstalar.',
    okInstalado: 'Instalado: {{lista}}',
    okJaInstalado: 'El módulo ya estaba instalado',
    okDesinstalado: '{{nome}} desinstalado',
    ligadoNoWorkspace: 'Activado en este workspace',
    desligadoNoWorkspace: 'Desactivado en este workspace',
    porWorkspace: 'Por workspace',
    porWorkspaceAjuda: 'Módulo opcional: nace desactivado y solo aparece en el workspace que lo active (los datos se conservan).',
    ligarNoWorkspace: 'Activar en este workspace',
    desligarNoWorkspace: 'Desactivar en este workspace',
    confirmarLigar: '¿Activar {{nome}} en este workspace?',
    ligarTexto: 'Los menús, rutas, tools del MCP e indicadores del módulo pasan a aparecer en {{workspace}}, para todas las empresas.',
    confirmarDesligar: '¿Desactivar {{nome}} en este workspace?',
    desligarTexto: 'Los menús, rutas, tools del MCP e indicadores del módulo desaparecen de {{workspace}}. Los datos se conservan y vuelven al activarlo de nuevo.',
    okLigado: '{{nome}} activado en este workspace',
    okDesligado: '{{nome}} desactivado en este workspace',
    menu: 'Menú',
    abas: 'Pestañas',
    permissoes_one: '{{count}} permiso', permissoes_other: '{{count}} permisos',
    vazio: 'El catálogo de módulos está vacío.',
  },
  tenants: {
    workspaces: 'Workspaces del tenant',
    novoWorkspace: 'Nuevo workspace',
    nome: 'Nombre',
    slug: 'Identificador',
    slugAjuda: 'Letras minúsculas, números y guion. Si queda vacío, se genera a partir del nombre.',
    sandbox: 'Sandbox',
    sandboxAjuda: 'Entorno de pruebas, separado de los datos reales.',
    atual: 'Actual',
    membros_one: '{{count}} miembro', membros_other: '{{count}} miembros',
    renomear: 'Renombrar',
    marcarSandbox: 'Marcar como sandbox',
    desmarcarSandbox: 'Quitar de sandbox',
    editarWorkspace: 'Editar workspace',
    excluirWorkspace: '¿Eliminar el workspace {{nome}}?',
    excluirWorkspaceTexto: 'No se borra nada: el workspace se archiva con todo lo que tiene y nadie entra más (sus sesiones y claves de API se detienen al momento). Solo quien es TI en un workspace de producción elimina, y nunca el workspace en uso.',
    excluirTenant: '¿Eliminar el tenant {{nome}}?',
    excluirTenantTexto: 'No se borra nada: el tenant se cancela y se archiva con todos sus workspaces y datos, y nadie de él entra más. Sale de esta lista. El propio tenant no se puede eliminar.',
    workspaceCriado: 'Workspace creado',
    vazioWorkspaces: 'Ningún workspace encontrado.',
    plataforma: 'Plataforma',
    plataformaTexto: 'Todos los tenants de la plataforma. Esta sección aparece solo para administradores de la plataforma.',
    novoTenant: 'Nuevo tenant',
    tenant: 'Tenant',
    plano: 'Plan',
    creditosQtd_one: '{{valor}} crédito', creditosQtd_other: '{{valor}} créditos',
    creditos: 'Créditos',
    estado: 'Estado',
    estados: { ativo: 'Activo', suspenso: 'Suspendido', cancelado: 'Cancelado' },
    qtdWorkspaces: 'Workspaces',
    qtdUsuarios: 'Usuarios',
    criadoEm: 'Creado el',
    donoNome: 'Nombre de quien será TI',
    donoEmail: 'Correo de quien será TI',
    workspaceInicial: 'Nombre del primer workspace',
    conviteAviso: 'El dueño recibe un correo con el enlace para definir la contraseña y entrar. El enlace vale 72 horas.',
    tenantCriado: 'Tenant creado e invitación enviada',
    editarTenant: 'Editar {{nome}}',
    vazioTenants: 'Ningún tenant registrado.',
    semAcesso: 'Solo los administradores de la plataforma ven los tenants.',
  },
  usuarios: {
    subabas: { membros: 'Miembros', convites: 'Invitaciones', papeis: 'Roles', pedidos: 'Solicitudes' },
    pedidos: {
      texto: 'Solicitudes de cambio de correo o de nombre de usuario hechas por las personas en Mi cuenta. Aprobar el nombre de usuario lo cambia al instante; aprobar el correo envía el enlace de confirmación a la dirección nueva.',
      pendentes: 'Solicitudes pendientes',
      nenhumPendente: 'Ninguna solicitud pendiente.',
      recentes: 'Decididas en los últimos 30 días',
      vazioTitulo: 'Ninguna solicitud',
      vazioTexto: 'Cuando alguien pida cambiar el correo o el nombre de usuario en Mi cuenta, la solicitud aparece aquí y recibes un aviso.',
      atual: { email: 'Correo actual', usuario: 'Nombre de usuario actual' },
      novo: { email: 'Correo solicitado', usuario: 'Nombre de usuario solicitado' },
      semEmail: 'Sin correo',
      aprovar: 'Aprobar',
      recusar: 'Rechazar',
      cancelar: 'Cancelar',
      status: { aprovado: 'Aprobada', recusado: 'Rechazada' },
      decidido: 'Decidida por {{quem}} el {{quando}}.',
      motivo: 'Motivo: {{motivo}}',
      aprovadoEmail: 'Solicitud aprobada: enviamos el enlace de confirmación al correo nuevo',
      aprovadoUsuario: 'Solicitud aprobada: el nombre de usuario ya cambió',
      recusado: 'Solicitud rechazada',
      recusarTitulo: 'Rechazar la solicitud',
      motivoCampo: 'Motivo (opcional)',
      motivoAjuda: 'La persona lee el motivo en Mi cuenta.',
    },
    arvore: {
      titulo: 'Acceso por subsistema, página y acción',
      ajudaSemSubsistemas: 'Los subsistemas están apagados en este workspace: la división estándar sirve de guía. Marca el grupo para dar todas sus páginas y acciones; ábrelo para desmarcar páginas y acciones (las acciones son del módulo y valen para todas sus páginas).',
      comuns: 'Comunes a todos',
      outras: 'Otros permisos',
      contagem: '{{marcadas}} de {{total}} páginas',
      acoesDoModulo: 'Acciones del módulo {{modulo}} (valen para todas sus páginas)',
      excecao: 'excepción',
      semConceder: 'No tienes esta acción para conceder',
      ajuda: 'Marca el subsistema en el que trabaja el rol: muestra solo las páginas de ese subsistema, y solo él queda abierto y marcado. Ábrelo para desmarcar páginas y, en cada página, acciones. Las acciones son del módulo y valen para todas sus páginas; la página que está en más de un subsistema es una sola (marcarla aquí la abre dondequiera que aparezca).',
      tambemEm: 'también en: {{lista}}',
      resumo: {
        papel: 'Este rol abre',
        pessoa: 'Esta persona abre',
        voce: 'Tú abres',
        paginas_one: '{{count}} página',
        paginas_other: '{{count}} páginas',
        comSubsistemas: '{{sujeito}}: {{paginas}} en {{lista}}',
        semSubsistemas: '{{sujeito}}: {{paginas}}',
        papelNenhuma: 'Este rol todavía no abre ninguna página.',
        pessoaNenhuma: 'Esta persona todavía no abre ninguna página.',
        voceNenhuma: 'Todavía no abres ninguna página.',
      },
    },
    acessoPersonalizado: 'Acceso personalizado',
    filtroAcesso: 'Filtrar por acceso',
    acessoTodos: 'Todo acceso',
    acessoPessoa: {
      titulo: 'Acceso de esta persona',
      ajuda: 'Parte de la suma de los roles. Marca o desmarca para conceder o quitar solo para esta persona (excepción, registrada en la auditoría). Prefiere resolverlo con roles.',
      desativado: 'Miembro desactivado: el acceso queda solo de lectura; reactívalo para editar',
      salvar: 'Guardar acceso',
      voltar: 'Volver solo a los roles',
      salvo: 'Acceso de la persona guardado',
      retiradasJunto: 'Quitadas junto con la acción concedida (no abres estas páginas): {{paginas}}.',
    },
    convidar: 'Invitar',
    novoPapel: 'Nuevo rol',
    nome: 'Nombre',
    email: 'Correo',
    papelUnico: 'Rol',
    papeis: 'Roles',
    estado: 'Estado',
    ativo: 'Activo',
    inativo: 'Desactivado',
    ultimoAcesso: 'Último acceso',
    formasAcesso: 'Acceso',
    nunca: 'Nunca ingresó',
    desde: 'Miembro desde',
    empresas: 'Empresas permitidas',
    empresasPelaFicha: 'Las empresas de esta persona siguen las verticales de su ficha de empleado (Personas): al cambiar las verticales allí, esta lista acompaña.', 
    empresasAjuda: 'Sin ninguna marcada, el usuario accede a todas las empresas del workspace. Con empresas marcadas, solo ve los datos de ellas (finanzas, cuentas, compras y nómina) y solo elige entre ellas en el filtro de empresa superior. Quien es TI ve siempre todas. Los informes consolidados y el Panel del grupo dependen del permiso de consolidado del rol o de la excepción de abajo.',
    empresasVeTodasRestrito: 'Este usuario no tiene lista de empresas: ve todas las empresas del workspace. Solo quien ve todas las empresas cambia su lista.',
    empresasOutras: 'También tiene empresas que no ves; siguen como están.',
    empresasAjudaRestrito: 'Con empresas marcadas, el usuario solo ve los datos de ellas (finanzas, cuentas, compras y nómina) y solo elige entre ellas en el filtro de empresa superior. Como no ves todas las empresas, la lista debe mantener al menos una marcada, y las empresas que no ves siguen como están. Los informes consolidados y el Panel del grupo dependen del permiso de consolidado del rol o de la excepción de abajo.',
    semEmpresas: 'Ninguna empresa registrada en este workspace.',
    salvarPapeis: 'Guardar roles',
    salvarEmpresas: 'Guardar empresas',
    consolidado: 'Ver el consolidado de las empresas (informes y Panel del grupo), como excepción',
    modoSimples: 'Modo simple',
    modoSimplesLigar: 'Activar el modo simple para esta persona',
    modoSimplesAjuda: 'Oculta las pestañas y los campos avanzados. La persona también puede activarlo o desactivarlo en Mi cuenta; ningún permiso cambia.',
    modoSimplesSalvar: 'Guardar modo simple',
    estilo: 'Estilo de interfaz',
    estiloAjuda: 'Fija el estilo de esta persona en este workspace: no puede cambiarlo. Sin fijar, vale su elección o el predeterminado del workspace.',
    estiloSeguir: 'No fijar (seguir la elección de la persona o el predeterminado del workspace)',
    estiloSalvar: 'Guardar estilo',
    estiloFixado: 'Estilo fijado: {{nome}}',
    definirEstilo: 'Definir estilo',
    estiloLoteTitulo: 'Definir el estilo de {{count}} persona(s)',
    estiloLoteSeguir: 'No fijar (seguir la elección de la persona o el predeterminado del workspace)',
    estiloLoteAplicar: 'Aplicar',
    selecionados_one: '{{count}} seleccionado',
    selecionados_other: '{{count}} seleccionados',
    limparSelecao: 'Limpiar selección',
    selecionar: 'Seleccionar {{nome}}',
    estiloAplicado: 'Estilo definido para {{count}} persona(s)',
    estiloParcial: 'Estilo definido para {{feitos}} de {{total}} personas; las demás siguen marcadas. {{erro}}',
    consolidadoAjuda: 'Habilita solo para esta persona la vista sumada de las empresas permitidas, sin cambiar el rol.',
    promoverDono: 'Promover a TI',
    promoverTitulo: '¿Promover a {{nome}} a TI?',
    promoverTexto: 'El rol TI tiene acceso total al workspace y puede promover a otros. Solo quien es TI hace esta promoción.',
    desativar: 'Desactivar',
    reativar: 'Reactivar',
    desativarTitulo: '¿Desactivar a {{nome}}?',
    remover: 'Quitar del workspace',
    removido: 'Miembro quitado del workspace',
    removerTitulo: '¿Quitar a {{nome}} del workspace?',
    removerTexto: 'La persona sale de la lista de miembros y se puede invitar de nuevo. No se borra nada: la auditoría y el historial de lo que hizo se conservan.',
    desativarTexto: 'La persona pierde el acceso a este workspace al instante. Su historial se conserva y se puede reactivar después.',
    autoDesativacao: 'No puedes desactivarte a ti mismo.',
    voce: 'tú',
    papelDonoAviso: 'Para dar a alguien el rol TI usa el botón Promover a TI.',
    vazioMembros: 'Ningún miembro encontrado.',
    filtroSituacao: 'Situación',
    todos: 'Todos',
    soAtivos: 'Activos',
    soInativos: 'Desactivados',
    convite: {
      titulo: 'Invitar al workspace',
      tipo: 'Tipo',
      tipos: { funcionario: 'Empleado', parceiro: 'Cliente o socio', convidado: 'Invitado' },
      tipoAjuda: {
        funcionario: 'Acceso al sistema vinculado a la ficha en Personas; el perfil viene de la función.',
        parceiro: 'Acceso al Portal del cliente, sin perfil del sistema.',
        convidado: 'Quien no es empleado (contador externo, consultor): solo el perfil.',
      },
      origem: 'Empleado',
      origens: { existente: 'Ya registrado en Personas, sin acceso', novo: 'Registrar ahora (solo nombre, correo, departamento, función y empresa)' },
      funcionario: 'Empleado sin acceso',
      funcionarioAjuda: 'Solo aparecen los que aún no tienen usuario ni invitación.',
      acesso: 'Cómo va a entrar la persona',
      acessos: { email: 'Invitación por correo', usuario: 'Nombre de usuario y contraseña provisoria (sin correo)' },
      acessoAjuda: {
        email: 'El enlace de la invitación va por correo y la persona define la contraseña. Puede ser el correo personal: lo cambia por el institucional después, en Mi cuenta, sin perder nada.',
        usuario: 'Para quien aún no tiene correo: entregas el nombre de usuario y la contraseña provisoria, que vale 72 horas y se cambia en el primer acceso. La recuperación de la contraseña queda con el administrador.',
      },
      emailAcesso: 'Correo de acceso (si no es el de la ficha)',
      emailAcessoAjuda: 'Ej.: el correo personal, antes del institucional. El correo de contacto de la ficha sigue igual.',
      emailContato: 'Correo de contacto (opcional)',
      usuario: 'Nombre de usuario',
      usuarioAjuda: 'En blanco: {{exemplo}} (generado por el nombre; si ya existe, recibe un número). Sin "@" y sin acento.',
      criarAcesso: 'Crear acceso',
      entrarEmail: 'Entrar con correo',
      entrarUsuario: 'Entrar con nombre de usuario',
      formasAjuda: 'Marca una o las dos. Con correo, la invitación lleva el enlace para que la persona cree su propia contraseña (y el nombre de usuario, si lo marcas). Solo nombre de usuario y sin correo: la contraseña provisoria aparece una vez para que tú la entregues.',
      formaObrigatoria: 'Elige al menos una forma de acceso',
      emailFichaAjuda: 'Vacío: el correo de la ficha. Puede ser otro (el personal, por ejemplo).',
      emailOpcionalAjuda: 'Opcional cuando solo marcas el nombre de usuario: con correo, la persona recibe el nombre de usuario y el enlace para crear la contraseña.',
      empresa: 'Empresa',
      empresaAtual: 'La empresa actual',
      papelFuncao: 'Perfil de acceso',
      papelFuncaoAjuda: 'El acceso viene del perfil. La función sugiere uno (ya viene completado); cámbialo si hace falta. Cambiar la función después no cambia el acceso.',
      novoAjuda: 'El CPF y la fecha de ingreso quedan por completar en la ficha (etiqueta "Datos por completar").',
      parceiro: 'Cliente o socio',
      papelPortal: 'Perfil en el Portal',
      semPortal: 'El Portal del cliente no está instalado en este workspace.',
      semPermissaoPortal: 'No tienes el permiso de accesos del Portal.',
      semPessoas: 'El módulo Personas no está instalado en este workspace.',
      semPermissaoPessoas: 'No tienes el permiso de editar en Personas.',
      enviadoPortal: 'Invitación del Portal enviada',
      enviar: 'Enviar invitación',
      enviado: 'Invitación enviada',
      expiraEm: 'Vence {{quando}}',
      expirado: 'Vencida',
      reenviar: 'Reenviar',
      cancelar: 'Cancelar invitación',
      cancelarTitulo: '¿Cancelar la invitación de {{email}}?',
      cancelarTexto: 'El enlace ya enviado deja de funcionar.',
      reenviado: 'Invitación reenviada con enlace nuevo',
      cancelado: 'Invitación cancelada',
      convidadoPor: 'Invitado por {{nome}}',
      vazio: 'Ninguna invitación pendiente.',
      nomeAjuda: 'Opcional. La persona puede ajustarlo al aceptar.',
      editar: 'Editar',
      editarTitulo: 'Editar invitación',
      editado: 'Invitación actualizada. El enlace enviado sigue valiendo.',
      editadoNovoLink: 'Invitación enviada al nuevo correo. El enlace anterior dejó de abrir.',
      emailTrocaAviso: 'Cambiar el correo cancela esta invitación y envía un enlace nuevo a la dirección nueva; el enlace actual deja de abrir. Cambiar lo demás mantiene el enlace y el plazo.',
      empresasConvite: 'Empresas',
      empresasConviteAjuda: 'Ninguna marcada: todas las empresas que ves.',
      salvar: 'Guardar invitación',
      detalheTitulo: 'Invitación de {{nome}}',
      detalheSemFicha: 'Esta persona no tiene ficha en el sistema.',
      criarFicha: 'Crear ficha',
      criarFichaAjuda: 'Crea la persona en Registros > Personas y empresas con el nombre y el correo de la invitación.',
      fichaCriada: 'Ficha creada',
      abrirFicha: 'Abrir la ficha de {{nome}}',
      verConvite: 'Ver la invitación de {{nome}}',
    },
    papel: {
      deFabrica: 'De fábrica',
      personalizado: 'Personalizado',
      membros_one: '{{count}} miembro', membros_other: '{{count}} miembros',
      permissoes_one: '{{count}} permiso', permissoes_other: '{{count}} permisos',
      imutavel: 'Los roles de fábrica no se pueden editar. Crea un rol personalizado para ajustar permisos.',
      matriz: 'Permisos por módulo',
      marcarTodas: 'Marcar todos',
      nucleo: 'Núcleo',
      nomeLabel: 'Nombre del rol',
      criarTitulo: 'Nuevo rol personalizado',
      duplicar: 'Duplicar',
      duplicarTitulo: 'Duplicar el rol {{nome}}',
      duplicarTexto: 'El rol nuevo empieza con los permisos, los niveles de los asistentes y las notificaciones predeterminadas de {{nome}}. Ajusta lo que quieras antes de crearlo.',
      nomeCopia: '{{nome}} (copia)',
      copiaParcial: 'Rol creado, pero no se copiaron los niveles de los asistentes o las notificaciones predeterminadas: {{erro}}',
      criado: 'Rol creado',
      excluir: 'Eliminar rol',
      excluirTitulo: '¿Eliminar el rol {{nome}}?',
      excluirTexto: 'Solo se pueden eliminar roles sin miembros ni invitaciones pendientes.',
      excluido: 'Rol eliminado',
      vazio: 'Ningún rol encontrado.',
      semModulos: 'No hay módulo con permisos instalado.',
    },
    conta: {
      titulo: 'Acceso a la cuenta',
      semEmail: 'Sin correo (entra con el nombre de usuario)',
      usuarioRotulo: 'Usuario: {{usuario}}',
      emailTexto: 'El enlace de confirmación va al correo nuevo; el cambio solo vale después de él y el correo actual recibe un aviso. El historial, los roles y la verificación en dos pasos se mantienen. No vale para quien también es miembro de otro workspace donde no eres TI.',
      emailNovo: 'Correo nuevo',
      trocarEmail: 'Cambiar correo',
      adicionarEmail: 'Agregar correo',
      emailEnviado: 'Si la dirección se puede usar, se le envió el enlace de confirmación.',
      novaSenha: 'Nueva contraseña provisoria',
      novaSenhaTexto: 'Para la cuenta sin correo que perdió la contraseña: la recuperación es con el administrador.',
      novaSenhaConfirmar: 'La contraseña actual y las sesiones abiertas de la persona dejan de valer. La nueva contraseña aparece una vez para que la entregues; vale 72 horas y se cambia en el primer acceso.',
    },
    acessoCriado: {
      titulo: 'Acceso creado',
      texto: 'Entrega estos datos a la persona. La contraseña provisoria aparece solo ahora, vale hasta {{quando}} y se cambiará en el primer acceso.',
      usuario: 'Nombre de usuario',
      senha: 'Contraseña provisoria',
      copiar: 'Copiar los datos',
      copiado: 'Copiado',
      fechar: 'Ya los entregué',
    },
    mfaTitulo: 'Verificación en dos pasos', mfaResetar: 'Restablecer verificación en dos pasos', mfaResetarTexto: 'Úsalo cuando la persona perdió el celular y los códigos de respaldo. La aplicación actual deja de valer y, si el rol lo exige, la configura de nuevo en el próximo inicio de sesión.', mfaResetado: 'Verificación en dos pasos restablecida',
    teste: { titulo: 'Usuario de prueba', selo: 'Prueba', texto: 'Cuenta de demostración sin inicio de sesión propio: quien tiene "Simular usuario de prueba" entra en ella desde el menú del perfil. Solo la cuenta que nunca inició sesión puede ser de prueba. Marcarla quita la contraseña, cierra las sesiones y revoca las claves de API, asistentes y conexiones de la cuenta.', seloSimulacao: 'Simulación', textoSimulacao: 'Usuario de simulación de este rol: nace con el rol y sale con él, no tiene inicio de sesión propio y solo el administrador de la plataforma lo ve y lo simula. Su acceso cambia aquí como el de cualquier persona (rol, empresas y excepciones), menos TI.', marcar: 'Marcar como usuario de prueba', desmarcar: 'Dejar de ser usuario de prueba', marcado: 'Marcado como usuario de prueba', desmarcado: 'Dejó de ser usuario de prueba', soSemEmail: 'Solo la cuenta sin correo (acceso por nombre de usuario) puede ser usuario de prueba.' },
    acaoPermissao: {
      consolidado: 'Consolidado de las empresas (informes y Panel del grupo)',
      erros: { ver: 'Ver el registro de errores' },
      adm: { usar: 'Usar el ADM' },
      subsistemas: { configurar: 'Configurar subsistemas' },
      erp: { usar: 'Usar el ERP' },
      crm: { usar: 'Usar el CRM' },
      suporte: { usar: 'Usar Soporte' },
      automacoes: { usar: 'Usar Automatizaciones' },
      rh: { usar: 'Usar RR. HH.' },
      ver: 'Ver',
      criar: 'Crear',
      editar: 'Editar',
      excluir: 'Eliminar',
      importar: 'Importar',
      mesclar: 'Fusionar',
      modulos: 'Módulos',
      usuarios: 'Usuarios',
      papeis: 'Roles',
      auditoria: 'Auditoría',
      tenants: 'Tenants',
      fechar: 'Cerrar',
      confidencial: 'Salario, documentos y datos personales',
      campos_telas: 'Configurar los campos de las pantallas',
      aprovar: 'Aprobar',
      salvar: 'Guardar',
      compartilhar: 'Compartir',
      agendar: 'Programar envío',
      arquivos: 'Gestionar la Central de archivos',
      // FUN 2026-10-15 (U7): permissões do módulo Automações por área.
      ver_todas: 'Ver todas las áreas',
      area_fiscal: 'Área Fiscal',
      area_dp: 'Área Nómina',
      area_bpo: 'Área BPO',
      area_legalizacao: 'Área Legalización',
      area_ti: 'Área TI',
      simular_usuario: 'Simular usuario de prueba',
    },
    // Val5 (29/10): rótulo próprio da ação de um módulo (`<modulo>.<acao>`), quando o genérico por ação não diz o que ela faz.
    acaoModulo: {
      agenda: { cancelar: 'Cancelar y reprogramar citas', bloquear: 'Bloquear horarios' },
      assinaturas: { faturar: 'Facturar contrato', pausar: 'Pausar y reactivar contrato', configurar: 'Configurar suscripciones' },
      ausencias: { exportar: 'Exportar ausencias' },
      automacoes: { publicar: 'Publicar flujo', disparar: 'Enviar envío masivo', configurar: 'Configurar automatizaciones' },
      cadastros: { exportar: 'Exportar contactos y empresas', arquivar: 'Archivar y desarchivar' },
      compras: { enviar: 'Enviar pedido al proveedor' },
      configuracoes: { empresas: 'Gestionar empresas del grupo', campos: 'Gestionar campos personalizados' },
      conversas: { configurar: 'Configurar canales y atención', templates: 'Gestionar plantillas de WhatsApp' },
      documentos: { enviar: 'Enviar para firma', cancelar: 'Cancelar firma' },
      estoque: { importar: 'Importar productos' },
      folha: { configurar: 'Configurar la nómina' },
      pessoas: { importar: 'Importar empleados', desligar: 'Dar de baja al empleado', convidar: 'Invitar al sistema', configurar: 'Configurar estructura de personas' },
      pipeline: { exportar: 'Exportar negociaciones y tareas', ganhar_perder: 'Marcar venta o pérdida (y reabrir)', configurar: 'Configurar el CRM', metas: 'Definir metas y equipos', enviar: 'Enviar e-mail y propuesta', em_massa: 'Acciones masivas' },
      relatorios: { publicar_portal: 'Publicar informe en el Portal' },
      tarefas: { configurar: 'Configurar tableros y proyectos' },
      treinamento: { atribuir: 'Asignar capacitaciones', acompanhar: 'Seguir el progreso del equipo' },
    },
  },
  erros: {
    intro: 'Cuando una acción falla, el sistema registra lo que la persona intentaba hacer, el error y lo que estaba completado (sin contraseña ni documento). Así el equipo, o una IA de apoyo, lo encuentra, lo corrige y rehace la acción antes de que la persona tenga que avisar. Cada error nuevo también llega a las Notificaciones.',
    quando: 'Cuándo',
    pessoa: 'Persona',
    acao: 'Acción que intentaba',
    tela: 'Pantalla',
    erro: 'Error',
    situacao: 'Situación',
    status: { novo: 'Nuevo', analise: 'En análisis', corrigido: 'Corregido' },
    filtros: { abertos: 'Abiertos', novo: 'Nuevos', analise: 'En análisis', corrigido: 'Corregidos', todos: 'Todos' },
    vazio: 'Ningún error registrado',
    vazioFiltro: 'Ningún error en este filtro',
    vazioTexto: 'Para ver cómo funciona, usa "Simular error".',
    simular: 'Simular error',
    feedback: 'Comentario',
    acaoFeedback: 'Danos tu opinión',
    gravado: { botao: 'Botón', link: 'Enlace', opcao: 'Opción', secao: 'Sección', campo: 'Campo', carregarTela: 'Cargar la pantalla', foraDeClique: 'Fuera de un clic', simularErro: 'Simular error (prueba)', abrirTela: 'Abrir la pantalla', janela: 'ventana' },
    textoFeedback: 'Lo que la persona sugirió',
    erroDeTeste: 'Error de prueba: el botón simuló una falla al guardar',
    detalhe: 'Error registrado',
    acaoTentava: 'Lo que la persona intentaba hacer',
    preenchido: 'Lo que estaba completado',
    nadaPreenchido: 'Ningún campo abierto.',
    navegador: 'Navegador',
    notas: 'Notas del equipo',
    notaPlaceholder: 'Causa, corrección, versión...',
    notaSalva: 'Nota guardada',
    copiarRelato: 'Copiar informe para la IA',
    copiado: 'Informe copiado',
    naoCopiou: 'No se pudo copiar. Selecciona el texto y cópialo.',
    executarDeNovo: 'Ejecutar la acción de nuevo',
    executou: 'Acción ejecutada de nuevo',
    abrirTela: 'Abrir la pantalla',
    soNaMesmaAba: 'Ejecutar de nuevo solo funciona en la misma pestaña del navegador donde ocurrió el error. Fuera de ella, "Abrir la pantalla" lleva al mismo lugar.',
    emAnalise: 'En análisis',
    marcarCorrigido: 'Marcar corregido',
    reabrir: 'Reabrir',
    mudou: { novo: 'Error reabierto', analise: 'Error en análisis', corrigido: 'Error marcado como corregido' },
    dadosOcultos: 'Lo que estaba completado queda oculto: el error es de una empresa o de un módulo que no ves.',
    relato: {
      intro: 'Error en una pantalla de MalgoOS. Analice la causa, proponga la corrección en el código y diga cómo rehacer lo que la persona intentaba hacer.',
      quando: 'Cuándo',
      pessoa: 'Persona',
      acao: 'Acción que intentaba',
      tela: 'Pantalla',
      origem: 'Origen',
      erro: 'Error',
      requestId: 'request_id (log de la API)',
      pilha: 'Pila',
      semPilha: '(sin pila)',
      dados: 'Datos completados en el momento',
      dadosOcultos: '(ocultos para quien copió)',
      navegador: 'Navegador',
    },
  },
  auditoria: {
    data: 'Fecha',
    usuario: 'Usuario',
    acao: 'Acción',
    entidade: 'Entidad',
    registro: 'Registro',
    ip: 'IP',
    requisicao: 'Solicitud',
    todosUsuarios: 'Todos los usuarios',
    todasEntidades: 'Todas las entidades',
    todasAcoes: 'Todas las acciones',
    de: 'Desde',
    ate: 'Hasta',
    detalhe: 'Detalle del registro',
    mudancas: 'Cambios',
    campo: 'Campo',
    antes: 'Antes',
    depois: 'Después',
    adicionado: 'Agregado',
    removido: 'Eliminado',
    alterado: 'Cambiado',
    semMudancas: 'Ninguna diferencia registrada en este evento.',
    verJson: 'Ver datos completos',
    ocultadoConteudo: 'El contenido de este registro se ocultó por tu permiso: falta acceso al módulo dueño del dato.',
    ocultadoCampos: 'Parte del contenido se ocultó por tu permiso.',
    sistema: 'Sistema',
    chaveApi: 'Clave de API',
    simuladoPor: 'simulado por {{nome}}',
    vazio: 'Ningún registro para los filtros elegidos.',
    limpar: 'Limpiar filtros',
  },
  saude: {
    versoes: 'Versiones',
    aplicacao: 'Aplicación',
    node: 'Node.js',
    postgres: 'PostgreSQL',
    worker: 'Worker',
    sinal: 'Señal del worker',
    modulos: 'Módulos del catálogo',
    fila: 'Cola de envío (outbox)',
    filaAgora: 'Pendientes en toda la base',
    filaMaisAntigo: 'el más antiguo {{quando}}',
    filaVazia: 'Nada pendiente. La cola está al día.',
    fila24h: 'Últimas 24 horas',
    jobsPorTipo: 'Jobs por tipo en las últimas 24 horas',
    tipo: 'Tipo',
    estado: 'Estado',
    total: 'Total',
    erros: 'Jobs con error',
    semErros: 'Ningún error registrado.',
    tentativas_one: '{{count}} intento', tentativas_other: '{{count}} intentos',
    webhooks: 'Webhooks que fallaron',
    eventosErro: 'Eventos recibidos con error',
    conector: 'Conector',
    resposta: 'Respuesta',
    atualizar: 'Actualizar',
    semSinal: 'Sin señal',
  },  historico: {
    intro_one: '{{count}} pantalla comparada, antes y después. Haz clic en una imagen para ampliarla.',
    intro_other: '{{count}} pantallas comparadas, antes y después. Haz clic en una imagen para ampliarla.',
    geradoEm: 'Catálogo del {{quando}}.',
    antes: 'Antes',
    depois: 'Después',
    celularAntes: 'Móvil · antes',
    celularDepois: 'Móvil · después',
    semAntes: 'Nuevo, sin antes',
    semCaptura: 'Sin captura',
    imagem: '{{titulo}}: {{rotulo}}',
    imagemN: '{{titulo}}: {{rotulo}} ({{n}} de {{total}})',
    ampliar: 'Ampliar {{nome}}',
    oculta: 'Imagen oculta en el modo discreto',
    vazioTitulo: 'Historial de pantallas aún no publicado',
    vazioTexto: 'Las imágenes están en el servidor, fuera del sistema. Publica el catálogo con la guía de operación para que aparezcan aquí.',
    vazioSemItens: 'El catálogo publicado no tiene ninguna pantalla.',
  },
  telaEntrada: {
    intro: 'El logo y la imagen de fondo del inicio y del cierre de sesión valen para todos los workspaces, porque la pantalla aparece antes del inicio de sesión. Solo el administrador de la plataforma los cambia.',
    textos: {
      cartao: 'Textos de la pantalla',
      ajuda: 'La llamada, el título y el subtítulo que aparecen junto al formulario en la computadora. Déjalos en blanco para usar el texto predeterminado (el gris dentro del campo), que cambia con el idioma de quien abre; el texto que escribas vale para todos los idiomas.',
      kicker: 'Llamada (encima del título)',
      titulo: 'Título',
      subtitulo: 'Subtítulo',
      limite: '{{usados}} de {{max}} caracteres',
      salvar: 'Guardar textos',
      voltarPadrao: 'Volver a los textos predeterminados',
      salvos: 'Textos de la pantalla de entrada guardados.',
      restaurados: 'Los textos predeterminados volvieron a la pantalla de entrada.',
    },
    padrao: 'Predeterminado',
    personalizada: 'Personalizada',
    atualizadaEm: 'Cambiada el {{quando}}',
    escolher: 'Elegir imagen',
    trocar: 'Cambiar imagen',
    salvar: 'Guardar',
    descartar: 'Descartar',
    voltarPadrao: 'Volver al predeterminado',
    confirmarPadraoTitulo: '¿Volver al predeterminado?',
    confirmarPadraoFundo: 'La pantalla de entrada vuelve a mostrar la foto del faro para todos.',
    confirmarPadraoLogo: 'La pantalla de entrada vuelve a mostrar el logo de Malgo para todos.',
    salva: 'Pantalla de entrada actualizada',
    processando: 'Enviando y procesando la imagen en el servidor; puede tardar hasta un minuto.',
    restaurada: 'Predeterminado restaurado',
    tipoInvalido: 'Elige una imagen PNG, JPG o WebP. SVG y otros formatos no se aceptan.',
    grandeDemais: 'Archivo de más de 20 MB. Elige una imagen más pequeña.',
    naoAbriu: 'No se pudo abrir esta imagen. Elige otro archivo.',
    resultado: 'Resultado del ajuste: {{largura}} × {{altura}} px, {{tamanho}}. Revisa la vista previa y guarda.',
    resultadoAlt: 'Resultado del ajuste',
    atualAlt: 'Imagen en uso',
    dicasTitulo: 'Consejos',
    fundo: {
      titulo: 'Imagen de fondo',
      padraoTexto: 'Foto del faro (predeterminada de Malgo)',
      dica1: 'Tamaño ideal: 1920 × 1080 px (proporción 16:9).',
      dica2: 'JPG o WebP, hasta unos 500 KB.',
      dica3: 'Deja el motivo principal en el centro: en la computadora el formulario cubre la mitad derecha y, en el celular, la parte de abajo.',
      dica4: 'La herramienta de ajuste recorta en 16:9, reduce y comprime antes de enviar.',
    },
    logo: {
      titulo: 'Logo',
      padraoTexto: 'Logo de Malgo (predeterminado)',
      dica1: 'Tamaño ideal: unos 400 × 120 px; aparece con hasta 200 px de ancho.',
      dica2: 'PNG o WebP con fondo transparente.',
      dica3: 'Prefiere el logo blanco o claro: aparece sobre la franja oscura de la marca y, en los estilos de franja clara (como Cupertino), el inicio de sesión pone una placa oscura discreta debajo. Revisa la vista previa.',
      dica4: 'La herramienta de ajuste recorta (proporción de 1:1 a 5:1) y reduce antes de enviar.',
    },
    recorte: {
      area: 'Área de recorte',
      ajuda: 'Arrastra la imagen o usa las flechas (con Shift avanza más); la rueda del ratón y las teclas + y - cambian el zoom.',
      zoom: 'Zoom',
      proporcao: 'Proporción (ancho ÷ alto): {{valor}}',
      saida: 'Sale con {{largura}} × {{altura}} px',
      usar: 'Usar este recorte',
      cancelar: 'Cancelar',
      falhou: 'No se pudo generar la imagen en este navegador. Prueba otro archivo u otro navegador.',
    },
    previa: {
      titulo: 'Vista previa de la pantalla de entrada',
      texto: 'Cómo queda en la computadora y en el celular, en los temas claro y oscuro, incluso lo que aún no se guardó.',
      computador: 'Computadora',
      celular: 'Celular',
      claro: 'tema claro',
      escuro: 'tema oscuro',
      legenda: '{{aparelho}}, {{tema}}',
      malgo: 'Estilo Malgo (predeterminado)',
      clara: 'Estilos con franja clara (como Cupertino)',
    },
  },
  usoIa: {
    ajuda: 'Tokens de Claude Code medidos en el Mac (sesión principal y agentes), con el costo equivalente a precio de API según la tabla oficial de Anthropic. No es la factura del plan: sirve para comparar días, modelos y proyectos.',
    granularidade: 'Agrupar por',
    por: { dia: 'Día', semana: 'Semana', mes: 'Mes', ano: 'Año' },
    navegar: 'Período',
    anterior: 'Período anterior',
    proximo: 'Período siguiente',
    semanaDe: 'Semana del {{data}}',
    filtroProjeto: 'Proyecto',
    filtroTipo: 'Tipo',
    todos: 'Todos',
    tipo: { principal: 'Sesión principal', agente: 'Agentes' },
    vazio: 'Todavía no se recibió ningún uso',
    vazioTexto: 'Ejecuta el medidor en el Mac (node scripts/uso-ia/medir.mjs --enviar) para que los números aparezcan aquí.',
    ind: {
      tokens: 'Tokens en el período',
      mensagens: '{{n}} mensajes',
      usd: 'Costo en US$',
      semPreco: '{{n}} tokens de modelos sin precio en la tabla',
      brl: 'Costo en R$',
      cotacao: 'Cotización: R$ {{valor}} por US$',
      variacao: 'Variación',
      contra: 'Frente a {{periodo}}',
    },
    grafico: 'Evolución',
    graficoAria: 'Uso de IA del {{de}} al {{ate}}',
    graficoCusto: 'Costo en US$ por período; destacado, el período elegido.',
    graficoTokens: 'Tokens por período (ningún modelo con precio en la tabla); destacado, el período elegido.',
    porModelo: 'Modelo',
    porProjeto: 'Proyecto',
    porTipo: 'Tipo',
    serie: 'Períodos',
    semUsoNoPeriodo: 'Sin uso en este período.',
    semPreco: 'Modelo sin precio en la tabla oficial',
    participacaoTokens: 'Participación en los tokens: {{valor}}',
    col: {
      periodo: 'Período',
      mensagens: 'Mensajes',
      entrada: 'Entrada',
      cacheEscrito: 'Caché escrita',
      cacheLido: 'Caché leída',
      saida: 'Salida',
      total: 'Tokens',
      usd: 'US$',
      brl: 'R$',
      participacao: '% del período',
      variacao: 'Variación',
    },
    cotacao: {
      titulo: 'Cotización del dólar',
      rotulo: 'Reales por dólar',
      atualizada: 'Actualizada el {{quando}}',
      semCotacao: 'Sin cotización: ingresa una para ver los valores en R$',
      salvar: 'Guardar cotización',
      salva: 'Cotización guardada',
      invalida: 'Ingresa la cotización en reales por dólar, como 5,43',
    },
    rodape: 'Precios oficiales de Anthropic verificados el {{data}}.',
    fonte: 'Tabla de precios',
    ultimoEnvio: 'último envío el {{quando}} (datos hasta el {{dia}})',
  },
};

export const i18n = { pt, en, es };
